import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  setDefaultChannel,
  getDefaultChannel,
  getIssues,
  getProject,
  getServiceDeskProject,
  getAssisantSkills,
  getJiraBoards,
  deleteDefaultChannel,
  channelAdminConfig,
  updateChannelCommonData,
  deleteChannelConfigurations,
  searchJiraProjects,
  creatorAsAssignee,
  dropDownSearchJiraProjects,
  getConfluenceChannelConfig,
  addConfluenceChannelConfig,
  updateCommonChannelData,
  getCustomEmojis,
  getJiraProjectStatues,
  getAllResolutionsInTheDomain,
} from '../skills_action';
import {
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  MoreOutlined,
  EditOutlined,
  ConsoleSqlOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import {
  Button,
  Select,
  Modal,
  Input,
  Card,
  message,
  Spin,
  Alert,
  Layout,
  Switch,
  Radio,
  Space,
  Divider,
  Checkbox,
  Popconfirm,
  InputNumber,
} from 'antd';
import { Typography, Row, Col, Tooltip, Dropdown, Menu, Anchor } from 'antd';
import query from 'query-string';
import Subscriptions from './Subscriptions/Subscriptions';
import IssueModal from './Subscriptions/IssueModal';
import ChannelAdmins from './channel_admins';
import JiraChannelPreferences from './Jira_channel_preferences';
import ProjectRestriction from './projectRestriction';
import axios from 'axios';
// import { ExclamationCircleOutlined } from '@ant-design/icons';
import JiraIssueFields from './jiraIssueFields';
// import IssueCardCustomization from './issueCardFieldCustomization';
import IssueCardCustomizationInfo from './IssueCardCustomization/IssueCardFieldCustomizationInfo';
import ViewCardCustomization from './ViewCardCustomization/ViewCardCustomization';
import queryString from 'query-string';
import { guestOauthTokensForUsers } from '../../jiraoauth/jiraoauth.action';
import { getGuestOauthTokensForCloudUsers } from '../../jiraoauth/jiraOAuthCloud.action';
import RequestTypeRestriction from './requestTypeRestriction';
import GlobalGuestUserRestriction from './GuestUserRestriction';
import { emojis } from '../../../utils/slackemojis';
import { updateCommonChannelDataApi } from '../../skills/skills_action';
import EmojiPicker from './emojiPicker';
import InternalComment from './internal_comment';
import OffHourSetting from './offHourSetting';
const { Text, Paragraph } = Typography;
const { Option } = Select;
const { Content } = Layout;
const { Link } = Anchor;

const threadsync_options = [
  { label: 'All updates', value: 'all_updates' },
  { label: 'Comments & Status', value: 'comment_status' },
  { label: 'Status', value: 'status' },
  { label: 'Comments', value: 'comment' },
  { label: 'None', value: 'none' },
];
const setFieldValueValues = [
  {
    label: 'Parent',
    value: 'parent',
  },
  {
    label: 'Components',
    value: 'components',
  },
  {
    label: 'Sprint',
    value: 'sprint',
  },
  {
    label: 'Fix versions',
    value: 'fix_versions',
  },
  {
    label: 'Priority',
    value: 'priority',
  },
  {
    label: 'Team',
    value: 'team',
  },
  {
    label: 'Labels',
    value: 'labels',
  },
  {
    label: 'Test Team',
    value: 'test_team',
  },
  {
    label: 'Assignee',
    value: 'assignee',
  },
];

const defaultDetailedFields = [
  {
    index: 0,
    field: {
      name: 'Project',
      value: 'project',
    },
    fallback: {
      name: 'Issue Type',
      value: 'issuetype',
    },
  },
  {
    index: 1,
    field: {
      name: 'Issue Type',
      value: 'issuetype',
    },
    fallback: {
      name: 'Project',
      value: 'project',
    },
  },
  {
    index: 2,
    field: {
      name: 'Priority',
      value: 'priority',
    },
    fallback: {
      name: 'Assignee',
      value: 'assignee',
    },
  },
  {
    index: 0,
    field: {
      name: 'Assignee',
      value: 'assignee',
    },
    fallback: {
      name: 'Priority',
      value: 'priority',
    },
  },
];

const defaultCompactField = {
  field: {
    name: 'Status',
    value: 'status',
  },
  fallback: {
    name: 'Status',
    value: 'status',
  },
};

const allowedSchemaTypes = [
  'issuetype',
  'number',
  'string',
  'project',
  'sd-customerrequesttype',
  'resolution',
  'datetime',
  'date',
  'watches',
  'user',
  'securitylevel',
];

const allowedArrayWithTypes = ['user', 'string', 'number', 'version'];
const attributeText =
  'Created by Troopr from @@@slack_message_link@@@ posted by @@@user@@@ in @@@#slack_channel_name@@@';
const summaryLength = 250;
class JiraChannelPreference extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      linkedProject: null,
      linkedProjectName: '',
      linkedIssue: null,
      edit: false,
      error: {},
      preference: 'channel',
      setFieldValueModal: false,
      setFieldValueField: '',
      setFieldInputField: '',
      defaultloading: false,
      showChannelSetting: false,
      board: '',
      boardData: [],
      isChannelAdmin: true,
      currentChannelConfigs: false,
      currentChannelName: '',
      isGridSharedChannel: false,
      creatorAsAssignee: false,
      isTrooprAdded: true,
      numberOfFieldsInExpanded: 4,
      allFieldsInJira: [],
      fieldsSelectedDetailed: defaultDetailedFields,
      fieldSelectedCompact: defaultCompactField,
      showDescription: false,
      isThreadSync: false,
      requestorAsReporter: true,
      currentView: 1,
      projectLoading: false,
      subscription: null,
      // fields: [],
      tabView: false,
      updateChannelDefaultData: {},
      disable_CSAT_feedback: true,
      auto_create_issue: false,
      auto_create_issue_emoji: false,
      auto_create_issue_unattended: false,
      isUnfurl: true,
      isUnfurlLink: true,
      unfurlResponseInThread: true,
      disableLeadingMessage: false,
      disableAtMentionReporter: false,
      server_type: '',
      channel_type: '',
      showAllUpdatesInThread: false,
      update_type: 'comment_status',
      showThreadSyncConfigurationInModal: false,
      channelCommonData: null,
      auto_remind: {},
      emojiMarkers: false,
      emojiMarkersDetails: {
        issueAssigned: {
          emoji: ':eyes:',
          enabled: false,
        },
        issueCreated: {
          emoji: ':ticket:',
          enabled: false,
        },
        issueDone: {
          emoji: ':white_check_mark:',
          enabled: false,
        },
        issueUnattended: {
          emoji: ':man-raising-hand:',
          enabled: false,
        },
      },
      emojiOpenedBy: '',
      auto_create_disable_if_message_with_emoji: {
        isEnabled: false,
        emoji: ':loudspeaker:',
      },
      reminder_disable_if_message_with_emoji: {
        isEnabled: false,
        emoji: ':loudspeaker:',
      },
      openEmojiModal: false,
      openReminderEmojiModal: false,
      remiderModal: false,
      showIssueCardCustomizationModal: false,
      showViewCardCustomizationModal: false,
      rejectThreadUsers: false,
      threadParticationInfo: false,
      auto_suggest_in_wiki: false,
      enableAttributeText: false,
      attributeText: '',
      showAttributeTextField: false,
      summaryLength: summaryLength,
      showSummaryLengthInput: false,
      customEmojisFromSlack: [],
      selectedStatuses: [],
      allStatuses: [],
      selectedResolutions: [],
      allResolutions: [],
      openStatusModal: false,
      selectedDoneEmojiField: 'status',
      // blockedProjects : []
    };
    // this.showChannelSetting = this.showChannelSetting.bind(this);
  }

  columns = [
    {
      key: 'number',
      align: 'center',
      render: (text, record, index) => <Text>Attribute #{index + 1}</Text>,
      width: '25%',
    },
    {
      title: () => (
        <Text>
          Field{' '}
          <Tooltip
            title={`If the value for this field is not present for any issue, "Not available" will be shown`}
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </Text>
      ),
      key: 'field',
      align: 'center',
      render: (text, record, index) => (
        <Select
          defaultValue={
            this.state.fieldsSelectedDetailed.length === 4 &&
            this.state.fieldsSelectedDetailed[index].field.name
          }
          placeholder='Select a jira field'
          style={{ width: '100%' }}
          value={this.state.fieldsSelectedDetailed[index].field.name}
          onSelect={(e) => this.onDetailedFieldsSelect(e, 'field', index)}
          showSearch
        >
          {this.getAvailableFields(index).map((field) => {
            return (
              <Option key={field.id} value={field.name}>
                {field.name}
              </Option>
            );
          })}
        </Select>
      ),
      width: '37%',
    },
    // {
    //   title: () => <Text>Fallback Field <Tooltip title="When the jira field is not present in the issue, this field will be uesd."><QuestionCircleOutlined /></Tooltip></Text>,
    //   key: "field-fallback",
    //   align: "center",
    //   render: (text, record, index) => <Select
    //     defaultValue={this.state.fieldsSelectedDetailed.length === 4 && this.state.fieldsSelectedDetailed[index].fallback.name}
    //     placeholder="Select a jira field"
    //     style={{ width: "100%" }}
    //     onSelect={(e) => this.onDetailedFieldsSelect(e, "fallback", index)}
    //   >
    //     {defaultFields.map(field => {
    //       return <Option key={field.value} value={field.name}>{field.name}</Option>
    //     })}
    //   </Select>,
    //   width: "37%"
    // }
  ];

  descriptionToggle = () => {
    let data = {
      showDescription: !this.state.showDescription,
      fieldsSelectedDetailed: this.state.fieldsSelectedDetailed,
      fieldSelectedCompact: this.state.fieldSelectedCompact,
    };
    this.handleIssueCardConfigChanges(data);
  };

  componentDidMount() {
    const { commonChanneldata, user_now, channels, userChannels, skill } =
      this.props;
    const { channel_id, channel_type } = queryString.parse(
      window.location.search
    );
    let qs = query.parse(window.location.search);
    if (qs.subscription) {
      this.setState({ subscription: qs.subscription });
    }

    if (qs.isThreadSyncUrl) {
      this.setState({ showThreadSyncConfigurationInModal: true });
    }
    if (channel_id) {
      let redirect = false;
      if (!channel_type) {
        message.error('Channel type not found');
        redirect = true;
      }
      if (
        channel_type !== 'agent' &&
        channel_type !== 'support' &&
        channel_type !== 'project'
      ) {
        message.error('Channel type wrong');
        redirect = true;
      }

      if (redirect)
        this.props.history.push(
          `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${this.props.match.params.sub_skill}?view=channel_preferences`
        );
    }

    this.setState({ loading: true, projectLoading: true, channel_type }, () => {
      if (channel_type) this.getRequiredData();
    });

    // Check if Troopr is added Show Descto the current channel
    let Channel_id = this.props.channel.id;
    // let link = `/bot/slack/${this.props.match.params.wId}/checkIfMember/${Channel_id}`;
    let link = `/bot/api/w/${this.props.match.params.wId}/slack/checkIfMember/${Channel_id}`;
    axios
      .get(link)
      .then((res) => {
        res = res.data;
        if (res.success) {
          this.setState({
            isTrooprAdded: res.data,
          });
        }
      })
      .catch((e) => {
        this.setState({ isTrooprAdded: false });
      });
    let channelSettings = commonChanneldata.find(
      (channel) => channel.channel_id === this.props.channel.id
    );
    // Thread Sync Toggle
    if (channelSettings) {
      // if(channelSettings.threadsync_type){
      //   update_type=
      // }
      this.setState({
        isThreadSync: channelSettings.isThreadSync,
        update_type:
          channelSettings.threadsync_type &&
          channelSettings.threadsync_type.update_type
            ? channelSettings.threadsync_type.update_type
            : 'none',
        showAllUpdatesInThread: channelSettings.showAllUpdatesInThread,
        isUnfurl: channelSettings.isUnfurl,
        isUnfurlLink: channelSettings.isUnfurlLink,
        unfurlResponseInThread: channelSettings.unfurlResponseInThread,
        disableLeadingMessage: channelSettings.disableLeadingMessage,
        disableAtMentionReporter: channelSettings.disableAtMentionReporter,
        channelCommonData: channelSettings,
        rejectThreadUsers: channelSettings.rejectThreadUsers,
        requestorAsReporter: channelSettings.hasOwnProperty(
          'requestorAsReporter'
        )
          ? channelSettings.requestorAsReporter
          : true,
        enableAttributeText:
          (channelSettings &&
            channelSettings.channelAttributionConfig &&
            channelSettings.channelAttributionConfig.enableAttributeText) ||
          false,
        attributeText:
          (channelSettings &&
            channelSettings.channelAttributionConfig &&
            channelSettings.channelAttributionConfig.attributeText) ||
          attributeText,
        summaryLength: (channelSettings && channelSettings.summaryLength) || 50,
        selectedStatuses:
          channelSettings.emojiMarkerStatuses &&
          channelSettings.emojiMarkerStatuses.length > 0
            ? channelSettings.emojiMarkerStatuses.map((status) => status.id)
            : [],
        selectedResolutions:
          channelSettings.emojiMarkerResolutions &&
          channelSettings.emojiMarkerResolutions.length > 0
            ? channelSettings.emojiMarkerResolutions.map(
                (resolution) => resolution.id
              )
            : [],
        selectedDoneEmojiField:
          (channelSettings && channelSettings.selectedEmojiMarkerField) ||
          'status',
      });

      this.setState({
        currentChannelConfigs: channelSettings,
        auto_create_issue: channelSettings.auto_create_in_channel || false,
        auto_create_issue_emoji:
          channelSettings.auto_create_in_channel_emoji || false,
        auto_create_issue_unattended:
          channelSettings.auto_create_in_channel_unattended || false,
        auto_remind: channelSettings.auto_remind,
      });

      if (
        channelSettings &&
        channelSettings.auto_create_disable_if_message_with_emoji
      ) {
        this.setState((prevState) => ({
          auto_create_disable_if_message_with_emoji: {
            ...prevState.auto_create_disable_if_message_with_emoji,
            isEnabled:
              channelSettings.auto_create_disable_if_message_with_emoji
                .isEnabled || false,
            emoji:
              channelSettings.auto_create_disable_if_message_with_emoji.emoji ||
              ':loudspeaker:',
          },
        }));
      }

      if (
        channelSettings &&
        channelSettings.reminder_disable_if_message_with_emoji
      ) {
        this.setState((prevState) => ({
          reminder_disable_if_message_with_emoji: {
            ...prevState.reminder_disable_if_message_with_emoji,
            isEnabled:
              channelSettings.reminder_disable_if_message_with_emoji
                .isEnabled || false,
            emoji:
              channelSettings.reminder_disable_if_message_with_emoji.emoji ||
              ':loudspeaker:',
          },
        }));
      }

      if (
        'restrict_channel_config' in channelSettings &&
        channelSettings.restrict_channel_config
      ) {
        const userFound = channelSettings.channel_admins.find(
          (user) =>
            user == user_now._id || (user && user.user_id === user_now._id)
        );
        if (userFound) this.setState({ isChannelAdmin: true });
        else this.setState({ isChannelAdmin: false });
      } else this.setState({ isChannelAdmin: true });

      if (channelSettings.issueCardCustomizationInfo) {
        this.setState({
          showDescription:
            channelSettings.issueCardCustomizationInfo.showDescription,
          fieldsSelectedDetailed:
            channelSettings.issueCardCustomizationInfo.fieldsSelectedDetailed,
          fieldSelectedCompact:
            channelSettings.issueCardCustomizationInfo.fieldSelectedCompact,
        });
      }
      if (
        'emojiMarkers' in channelSettings &&
        'emojiMarkersDetails' in channelSettings
      ) {
        this.setState({
          emojiMarkers: channelSettings.emojiMarkers,
          emojiMarkersDetails: channelSettings.emojiMarkersDetails,
        });
      }

      // if(channelSettings && channelSettings.projectRestriction && channelSettings.projectRestriction.restriction_type === "block" && channelSettings.projectRestriction.selected_projects && channelSettings.projectRestriction.selected_projects.length > 0){
      //   this.setState({blockedProjects : channelSettings.projectRestriction.selected_projects})
      // }

      // if restriction is false or is not configured, then we will allow all users to edit
    } else {
      if (channel_type) {
        message.error(`No configuration found`);
        this.props.history.push(
          `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${this.props.match.params.sub_skill}?view=channel_preferences`
        );

        // *** created new channel common data ***
        // const data = {
        //   channel_id: this.props.channel.id,
        //   skill_id: this.props.match.params.skill_id,
        //   channel: this.props.channel,
        //   channel_type,
        // };
        // this.props
        //   .updateChannelCommonData(data, this.props.match.params.wId)
        //   .then((res) => {
        //     console.log('new craeted', res)
        //   });
      }
    }

    //<<< handle channel name change >>>
    if (this.props.channel.id) {
      const selectedChannel = this.props.channels.find(
        (channel) => channel.id == this.props.channel.id
      );
      if (selectedChannel)
        this.setState({ currentChannelName: selectedChannel.name });
      else {
        if (this.props.channel_name) {
          this.setState({
            isTrooprAdded: false,
            currentChannelName: this.props.channel_name,
          });
        }
      }
    }

    getCustomEmojis(this.props.match.params.wId).then((emojis) => {
      this.setState({
        customEmojisFromSlack: emojis,
      });
    });
  }

  getRequiredData = () => {
    const { userChannels, channelDefault, commonChanneldata } = this.props;
    const { channel_id, channel_type } = queryString.parse(
      window.location.search
    );
    const skill =
      this.props.skill && this.props.skill.skill_metadata
        ? this.props.skill.skill_metadata
        : this.props.skill;

    if (skill && skill.metadata && skill.metadata.server_type) {
      this.setState({ server_type: skill.metadata.server_type }, () => {
        if (channel_type === 'support') {
          this.props
            .getServiceDeskProject(
              this.props.match.params.wId,
              this.props.match.params.skill_id,
              { saveInBoth: true }
            )
            .then((res) => this.setState({ projectLoading: false }));
        } else if (channel_type === 'agent') {
          if (
            this.state.server_type === 'jira_server_oauth' ||
            this.state.server_type === 'jira_server'
          ) {
            this.props
              .getProject(this.props.match.params.wId)
              .then((res) => this.setState({ projectLoading: false }));
          } else {
            this.props
              .searchJiraProjects(
                this.props.match.params.wId,
                '?query=typeKey=service_desk'
              )
              .then((res) => this.setState({ projectLoading: false }));
          }
        } else if (channel_type === 'project') {
          if (
            this.state.server_type === 'jira_server_oauth' ||
            this.state.server_type === 'jira_server'
          ) {
            this.props
              .getProject(this.props.match.params.wId)
              .then((res) => this.setState({ projectLoading: false }));
          } else {
            this.props
              .searchJiraProjects(
                this.props.match.params.wId,
                '?query=typeKey=software,business'
              )
              .then((res) => {
                if (res.data.success) {
                  const channelFound = commonChanneldata.find(
                    (cha) => cha.channel_id === channel_id
                  );
                  if (
                    channelFound &&
                    channelFound.channel_linking_id &&
                    channelFound.channel_linking_id.link_info &&
                    channelFound.channel_linking_id.link_info.project
                  ) {
                    const query = `id=${channelFound.channel_linking_id.link_info.project.id}`;
                    if (
                      !this.props.projects.find(
                        (pro) =>
                          pro.id ===
                          channelFound.channel_linking_id.link_info.project.id
                      )
                    ) {
                      this.props.dropDownSearchJiraProjects(
                        this.props.match.params.wId,
                        `?query=${query}`
                      );
                    }
                  }
                  this.getMissingProjects(); /* to get missing proects in project restriction list */
                }
                this.setState({ projectLoading: false });
              });
          }
        } else {
          this.props
            .getProject(this.props.match.params.wId)
            .then((res) => this.setState({ projectLoading: false }));
        }
      });
    }

    //checking if it's enterprice shared channel or not
    const channelFound = userChannels.find(
      (cha) => cha.id === this.props.channel.id
    );
    let isGridSharedChannel = false;
    if (
      channelFound &&
      channelFound.is_org_shared &&
      channelFound.enterprise_id
    ) {
      isGridSharedChannel = true;
      this.setState({ isGridSharedChannel: true });
    }

    this.props
      .getDefaultChannel(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        this.props.channel.id,
        /*to handle "type"*/ false,
        isGridSharedChannel
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success) {
          // if(res.data.link_info){
          //   if(res.data.link_info.isSupportChannel) this.props.getServiceDeskProject(this.props.match.params.wId,this.props.match.params.skill_id).then(res => this.setState({projectLoading:false}))
          //   else this.props.getProject(this.props.match.params.wId).then(res => this.setState({projectLoading:false}))
          // }else{
          //   this.props.getProject(this.props.match.params.wId).then(res => this.setState({projectLoading:false}));
          // }
          if (res.data.link_info) {
            this.setState({
              linkedProjectName: res.data.link_info.link_info.project_name,
              linkedProject: res.data.link_info.link_info.project_id,
              linkedIssue:
                channel_type === 'support'
                  ? res.data.link_info.link_info.requestType &&
                    res.data.link_info.link_info.requestType.name
                  : res.data.link_info.link_info.issue_id,
              board: res.data.link_info.link_info.board
                ? res.data.link_info.link_info.board.id.toString()
                : null,
              disable_CSAT_feedback: res.data.link_info.link_info
                .disable_CSAT_feedback
                ? true
                : false,
            });
            this.props.getIssues(
              this.props.match.params.wId,
              channel_type === 'support'
                ? res.data.link_info.link_info.project_service_desk_id
                : res.data.link_info.link_info.project_id,
              // this.props.isSupportChannel
              channel_type === 'support' ? true : false
            );

            // if(res.data.link_info.link_info.board){
            let query = 'projectKeyOrId=' + this.state.linkedProject;
            this.props
              .getJiraBoards(this.props.match.params.wId, query)
              .then((boardData) => {
                if (
                  boardData &&
                  boardData.data &&
                  boardData.data.boards &&
                  boardData.data.boards.length > 0 &&
                  boardData.data.boards[0].name
                ) {
                  // console.log('didmount',boardData)
                  this.setState({
                    /*board: boardData.data.boards[0].name*/ boardData:
                      boardData.data.boards,
                  });
                }
              });
            // }
          } else {
            this.setState({ linkedProject: '', linkedIssue: '' });
          }
        }
      });

    getAllResolutionsInTheDomain(this.props.match.params.wId).then((res) => {
      if (res.success) this.setState({ allResolutions: res.resolutions });
    });
  };

  getMissingProjects = () => {
    /* to get missing proects in project restriction list */
    const { commonChanneldata, projects } = this.props;
    let unavailableProjects = [];
    const channelFound = commonChanneldata.find(
      (data) =>
        data.channel_id === queryString.parse(window.location.search).channel_id
    );

    if (
      projects &&
      projects.length > 0 &&
      channelFound &&
      channelFound.projectRestriction &&
      channelFound.projectRestriction.selected_projects
    ) {
      const selected_projects =
        channelFound.projectRestriction.selected_projects;
      selected_projects.forEach((selected_project) => {
        if (!projects.find((project) => project.id === selected_project.id))
          unavailableProjects.push(selected_project);
      });
    }

    if (unavailableProjects.length > 0) {
      unavailableProjects.forEach((p) => {
        const query = `id=${p.id}`;
        this.props.dropDownSearchJiraProjects(
          this.props.match.params.wId,
          `?${query}&query=typeKey=software,business`
        );
      });
    }
  };

  removeGuestAuthorizationConfirm = async () => {
    const { isChannelAdmin } = this.state;

    if (!isChannelAdmin) {
      return message.warn(
        `Channel configuration access restricted.Contact one of the channel admins(or workspace admins) for access: ${this.getAdminNames()}`
      );
    }

    Modal.confirm({
      title: 'Revoke Guest Facilitation',
      icon: <ExclamationCircleOutlined />,
      content: <p>Are you sure you want revoke permissions?</p>,
      onOk: () => this.removeGuestAuthorization(),
      onCancel: () => {},
    });
  };

  removeGuestAuthorization = () => {
    const queryParams = queryString.parse(this.props.location.search);
    this.props.channelAdminConfig(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      queryParams.channel_id,
      { guestToken: null },
      this.state.isGridSharedChannel
    );
  };

  goToUserJiraLogin = async () => {
    const { skill } = this.props;
    const { isChannelAdmin } = this.state;
    if (!isChannelAdmin) {
      return message.warn(
        `Channel configuration access restricted.Contact one of the channel admins(or workspace admins) for access: ${this.getAdminNames()}`
      );
    }
    let servertype = skill && skill.metadata && skill.metadata.server_type;
    const queryParams = queryString.parse(this.props.location.search);
    if (servertype && servertype === 'jira_server_oauth') {
      let url = await guestOauthTokensForUsers(
        this.props.match.params.wId,
        this.props.match.params.sub_skill,
        queryParams
      );
      if (!url) {
        message.error(
          'Error Logging in make sure you connected to jira or disconnect and try connection jira again'
        );
      } else {
        window.open(url, '_blank');
      }
    } else if (servertype && servertype === 'jira_cloud_oauth') {
      let url = await getGuestOauthTokensForCloudUsers(
        this.props.match.params.wId,
        this.props.match.params.sub_skill,
        queryParams
      );
      if (!url) {
        message.error(
          'Error Logging in make sure you connected to jira or disconnect and try connection jira again'
        );
      } else {
        window.open(url, '_blank');
      }
    } else {
      const url = `/${this.props.match.params.wId}/jira_user_oauth/${this.props.match.params.skill_id}`;
      window.open(url, '_blank');
    }

    /*this.props.history.push("/workspace/"+this.props.workspace_id+"/jira_user_oauth/"+this.props.skill._id)*/
  };

  getValidFields = (fields) => {
    let validFields = [];
    if (!fields || !fields.length) return;
    fields.forEach((field) => {
      let schema = field.schema;
      let type = schema && schema.type;
      let items = schema && schema.items;
      if (!type) return;
      if (
        allowedSchemaTypes.includes(type) ||
        (type === 'array' && items && allowedArrayWithTypes.includes(items))
      ) {
        validFields.push(field);
      }
    });
    this.setState({
      allFieldsInJira: validFields,
    });
  };

  componentDidUpdate(prevProps) {
    const { commonChanneldata, user_now, channel } = this.props;
    // if (prevProps.channelDefault.creatorAsAssignee === undefined && this.props.channelDefault.creatorAsAssignee !== undefined) {
    //   this.setState({
    //     creatorAsAssignee: this.props.channelDefault.creatorAsAssignee,
    //   });
    // }
    if (prevProps.channelDefault !== this.props.channelDefault) {
      const channelFound = commonChanneldata.find(
        (cha) => cha.channel_id == channel.id
      );
      const projectId =
        (this.props.channelDefault &&
          this.props.channelDefault.link_info &&
          (this.props.channelDefault.link_info.project_id ||
            this.props.channelDefault.link_info.project.id)) ||
        (channelFound &&
          channelFound.channel_linking_id &&
          channelFound.channel_linking_id.link_info &&
          channelFound.channel_linking_id.link_info.project.id);
      if (projectId) {
        this.props
          .getJiraProjectStatues(
            this.props.match.params.wId,
            this.props.match.params.skill_id,
            projectId
          )
          .then((res) => {
            if (res.data.success) {
              this.setState({ allStatuses: res.data.statuses });
            }
          });
      }
    }

    if (
      prevProps.channelDefault !== this.props.channelDefault &&
      this.props.channelDefault._id
    )
      this.setState({
        creatorAsAssignee: this.props.channelDefault.creatorAsAssignee,
      });
    if (prevProps.commonChanneldata != commonChanneldata) {
      if (this.props.isWorkspaceAdimin) {
        this.setState({ isChannelAdmin: true });
      }
      // Check if Troopr is added to the current channel
      let channel_id = this.props.channel.id;
      // let link = `/bot/slack/${this.props.match.params.wId}/checkIfMember/${channel_id}`;
      let link = `/bot/api/w/${this.props.match.params.wId}/slack/checkIfMember/${channel_id}`;
      axios
        .get(link)
        .then((res) => {
          res = res.data;
          if (res.success) {
            this.setState({
              isTrooprAdded: res.data,
            });
          }
        })
        .catch((e) => {
          this.setState({ isTrooprAdded: false });
        });

      if (commonChanneldata) {
        const channelFound = commonChanneldata.find(
          (cha) => cha.channel_id == channel.id
        );
        // Thread Sync Toggle
        if (channelFound) {
          this.setState({
            channelCommonData: channelFound,
            isThreadSync: channelFound.isThreadSync,
            showAllUpdatesInThread: channelFound.showAllUpdatesInThread,
            isUnfurl: channelFound.isUnfurl,
            update_type:
              channelFound.threadsync_type &&
              channelFound.threadsync_type.update_type
                ? channelFound.threadsync_type.update_type
                : 'none',
          });
        }
        if (channelFound) {
          this.setState({
            currentChannelConfigs: channelFound,
            auto_create_issue: channelFound.auto_create_in_channel || false,
            auto_create_issue_emoji:
              channelFound.auto_create_in_channel_emoji || false,
            auto_create_issue_unattended:
              channelFound.auto_create_in_channel_unattended || false,
          });
          if (
            'restrict_channel_config' in channelFound &&
            channelFound.restrict_channel_config
          ) {
            const userFound = channelFound.channel_admins.find(
              (user) =>
                user == user_now._id || (user && user.user_id === user_now._id)
            );
            if (userFound) this.setState({ isChannelAdmin: true });
            else this.setState({ isChannelAdmin: false });
          } else this.setState({ isChannelAdmin: true });

          if (channelFound.issueCardCustomizationInfo) {
            this.setState({
              showDescription:
                channelFound.issueCardCustomizationInfo.showDescription,
              fieldsSelectedDetailed:
                channelFound.issueCardCustomizationInfo.fieldsSelectedDetailed,
              fieldSelectedCompact:
                channelFound.issueCardCustomizationInfo.fieldSelectedCompact,
            });
          }

          // if(channelFound && channelFound.projectRestriction && channelFound.projectRestriction.restriction_type === "block" && channelFound.projectRestriction.selected_projects && channelFound.projectRestriction.selected_projects.length > 0){
          //   this.setState({blockedProjects : channelFound.projectRestriction.selected_projects})
          // }
        }
        // if restriction is false or is not configured, then we will allow all users to edit
      }
    }

    if (prevProps.channels != this.props.channels) {
      //<<< handle channel name change >>>
      if (this.props.channel.id) {
        const selectedChannel = this.props.channels.find(
          (channel) => channel.id == this.props.channel.id
        );
        if (selectedChannel)
          this.setState({ currentChannelName: selectedChannel.name });
        else {
          if (this.props.channel_name) {
            this.setState({
              isTrooprAdded: false,
              currentChannelName: this.props.channel_name,
            });
          }
        }
      }
    }

    if (this.props.location.search !== prevProps.location.search) {
      let qs = queryString.parse(window.location.search);

      if (qs.subscription !== this.state.subscription) {
        this.setState({ subscription: qs.subscription });
      }
      const channel_type = qs.channel_type;
      this.setState({ channel_type }, () => this.getRequiredData());
    }
  }

  creatorAsAssigneeChange = () => {
    let skill_id = this.props.match.params.skill_id;
    let channel_id = this.props.channel.id;
    // let link = `/bot/api/skill/${skill_id}/channel_link/creatorAsAssignee/${channel_id}`;

    // if (this.state.isGridSharedChannel) link += `?isGridSharedChannel=true`;

    this.props
      .creatorAsAssignee({
        wId: this.props.match.params.wId,
        channeL: this.props.channel,
        skill_id,
        channel_id,
        isGridSharedChannel: this.state.isGridSharedChannel,
      })
      .then((data) => {
        if (data && data.data && data.data.success) {
          this.setState({
            creatorAsAssignee: data.data.data,
          });
        }
      });
    // axios
    //   .post(link,{channel:this.props.channel})
    //   .then((data) => {
    //     if (data && data.data && data.data.success) {
    //       this.setState({
    //         creatorAsAssignee: data.data.data,
    //       });
    //     }
    //   })
    //   .catch((error) => {});
  };

  threadSyncToggle = () => {
    let skill_id = this.props.match.params.skill_id;
    let channel_id = this.props.channel.id;
    let workspace_id = this.props.match.params.wId;
    // let link = `/bot/api/${workspace_id}/isThreadSync/${skill_id}/${channel_id}`;
    let link = `/bot/api/w/${workspace_id}/jira/isThreadSync/${skill_id}/${channel_id}`;
    if (this.state.isGridSharedChannel) link += `?isGridSharedChannel=true`;
    let data = {
      channel: this.props.channel,
      isThreadSync: !this.state.isThreadSync,
      channel_type: this.state.channel_type,
    };
    axios
      .post(link, data)
      .then((data) => {
        data = data.data;
        if (data && data.commonChannelData) {
          this.setState({ isThreadSync: data.commonChannelData.isThreadSync });
        }
      })
      .catch((error) => {
        message.error('Some error occurred. Please try again.');
      });
  };

  threadSyncConfigs = (property, checked) => {
    const queryParams = queryString.parse(this.props.location.search);
    this.props
      .channelAdminConfig(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        queryParams.channel_id,
        { [property]: !checked },
        this.state.isGridSharedChannel
      )
      .then((res) => {
        if (res.data.success)
          this.setState({ [property]: res.data.channelCommonData[property] });
      });
  };

  updateCommondata = (property, checked) => {
    const queryParams = queryString.parse(this.props.location.search);
    this.props
      .channelAdminConfig(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        queryParams.channel_id,
        { [property]: !checked },
        this.state.isGridSharedChannel
      )
      .then((res) => {
        // if (res.data.success)
        //   this.setState({ [property]: res.data.channelCommonData[property] });
      });
  };

  showAllUpdatesButtonToggle = (update_type) => {
    let skill_id = this.props.match.params.skill_id;
    let channel_id = this.props.channel.id;
    let workspace_id = this.props.match.params.wId;
    // let link = `/bot/api/${workspace_id}/isThreadSync/${skill_id}/${channel_id}`;
    let link = `/bot/api/w/${workspace_id}/jira/isThreadSync/${skill_id}/${channel_id}`;
    if (this.state.isGridSharedChannel) link += `?isGridSharedChannel=true`;
    let data = {
      channel: this.props.channel,
      threadsync_type: {
        type: update_type === 'none' ? 'slack_to_jira' : '2_way',
        update_type: update_type,
      },
      isThreadSync: this.state.isThreadSync,
      channel_type: this.state.channel_type,
    };

    axios
      .post(link, data)
      .then((data) => {
        data = data.data;
        message.success('Sync filter updated successfully');
        if (data && data.commonChannelData) {
          this.setState({ update_type: update_type });
        }
      })
      .catch((error) => {
        message.error('Some error occurred. Please try again.');
      });
  };

  onChangeProject = async (event, value) => {
    const { channel_type } = this.state;
    this.setState(
      { linkedProject: event, linkedProjectName: value.props.children },
      () => {
        let query = 'projectKeyOrId=' + this.state.linkedProject;
        channel_type !== 'support' &&
          this.props
            .getJiraBoards(this.props.match.params.wId, query)
            .then((boardData) => {
              if (
                boardData &&
                boardData.data &&
                boardData.data.boards &&
                boardData.data.boards.length > 0 &&
                boardData.data.boards[0].name
              ) {
                this.setState({
                  board: boardData.data.boards[0].id.toString(),
                  boardData: boardData.data.boards,
                });
              } else this.setState({ boardData: [], board: null });
            });
      }
    );
    this.props
      .getIssues(
        this.props.match.params.wId,
        channel_type === 'support' ? value.key : event,
        channel_type === 'support' ? true : false
      )
      .then((res) => {
        if (res.data.success) {
          this.setState(
            { linkedIssue: null /* res.data.issueTypes[0].value */ },
            () => {
              // if (!this.props.isSupportChannel) {
              //   // this.getIssueFields()
              //   // this.project_change_click_child()
              // }
            }
          );
        } else {
          this.setState(() => ({ linkedIssue: null }));
        }
      });
  };

  onChangeIssue = (event) => {
    this.setState({ linkedIssue: event }, () => {
      // if (!this.props.isSupportChannel) {
      //   // this.getIssueFields()
      //   // this.issue_change_click_child()
      // }
    });
  };

  getIssueFields = () => {
    axios
      // .get(`/bot/skill/${this.props.match.params.skill_id}/user/${this.props.user_now._id}/issueFieldsOfProject`, {
      .get(
        `/bot/api/w/${this.props.match.params.skill_id}/jira/${this.props.match.params.skill_id}/user/${this.props.user_now._id}/issueFieldsOfProject`,
        {
          params: {
            project_id: this.state.linkedProject,
            issueTypeName: this.state.linkedIssue,
            // params : {project_id : '10026',
            // issueTypeName : 'Task'
          },
        }
      )
      .then((res) => {
        // console.log(JSON.stringify(res.data.items.projects[0].issuetypes[0].fields))
        if (res.data.success)
          this.setState({
            fields: Object.values(
              res.data.items.projects[0].issuetypes[0].fields
            ),
          });
      })
      .catch((e) => {});
  };

  onChangeBoard = (event, value) => {
    this.setState({ board: value && value.key ? value.key : null });
  };

  onClickSave = async () => {
    try {
      const { issues, projects, commonChanneldata } = this.props;
      const { channel_type } = this.state;
      const channelId = this.props.channel.id;

      let error = {};
      let selectedBoardData =
        this.state.board &&
        this.state.boardData.find((board) => board.id == this.state.board);
      let selectedProjectData =
        projects &&
        projects.find(
          (project) =>
            (channel_type === 'support' ? project.projectId : project.id) ===
            this.state.linkedProject
        );
      let data = {
        link_info: {
          // issue_id: this.state.linkedIssue,
          project_id: this.state.linkedProject,
          project: selectedProjectData,
          // issue_field: this.state.setFieldValueField,
          // issue_value: this.state.setFieldInputValue,
          // issueName:selectedIssueData && selectedIssueData.value
        },
      };
      if (channel_type === 'support') {
        const config = commonChanneldata.find(
          (cha) => cha.channel_id === channelId
        );

        if (config) {
        } else {
          /* saving the channel as support channel in "Common channel data collection" */

          const common_data = {
            channel_id: channelId,
            skill_id: this.props.match.params.skill_id,
            channel: this.props.channel,
            isThreadSync: true,
            channel_type: 'support',
          };

          const common_data_res = await this.props.updateChannelCommonData(
            common_data,
            this.props.match.params.wId
          );
          if (common_data_res.success) {
          } else throw JSON.stringify(common_data_res);
        }

        const issueDataFound = this.props.issues.find(
          (issue) => issue.value === this.state.linkedIssue
        );
        const projectDataFound = this.props.projects.find(
          (project) => project.projectId === this.state.linkedProject
        );
        if (this.state.linkedIssue && issueDataFound)
          data.link_info.requestType = {
            name: this.state.linkedIssue,
            id: issueDataFound ? issueDataFound.id : null,
          };
        if (projectDataFound)
          data.link_info.project_service_desk_id = projectDataFound.id;
        data.link_info.disable_CSAT_feedback = this.state.disable_CSAT_feedback
          ? true
          : false;
      } else {
        let selectedIssueData =
          issues &&
          issues.find((issue) => issue.value == this.state.linkedIssue);
        data.link_info.issue_id = this.state.linkedIssue;
        data.link_info.issue_field = this.state.setFieldValueField;
        data.link_info.issue_value = this.state.setFieldInputValue;
        data.link_info.issueName = selectedIssueData && selectedIssueData.value;
        if (selectedIssueData) {
          data.link_info.issueType = {
            id: selectedIssueData.id,
            name: selectedIssueData.text,
          };
        }
      }
      if (selectedProjectData)
        data.link_info.project_name =
          channel_type === 'support'
            ? selectedProjectData.projectName +
              ` (${selectedProjectData.projectKey})`
            : selectedProjectData.name + ` (${selectedProjectData.key})`;
      // data.link_info.board = selectedBoardData ? {id:selectedBoardData.id, name:selectedBoardData.name} : null
      data.link_info.board = selectedBoardData ? selectedBoardData : null;
      data.channel_id = channelId;
      data.updated_by = localStorage.trooprUserId;
      data.skill_id = this.props.match.params.skill_id;
      if (
        (channel_type === 'support' ? true : data.link_info.issue_id) &&
        data.link_info.project &&
        data.link_info.project_id &&
        data.channel_id
      ) {
        this.setState(
          { defaultloading: true, updateChannelDefaultData: data },
          () => {
            if (channel_type === 'support') this.saveChannelDefault(data);
            else this.clickChild();
          }
        );

        // this.props.setDefaultChannel(this.props.match.params.skill_id, data,/*to handle "type" */false,this.state.isGridSharedChannel).then(res => {
        //   if (res.data.success) {
        //     this.setState({ defaultloading: false })
        //     message.success("Saved successfully");
        //     this.setState({ setFieldInputValue: res.data.link_info.link_info.issue_value, setFieldValueField: res.data.link_info.link_info.issue_field, linkedProject: res.data.link_info.link_info.project_id, linkedIssue: isSupportChannel ? res.data.link_info.link_info.requestType.name : res.data.link_info.link_info.issue_id, edit: false, error: {} });
        //     !res.data.link_info.link_info.board && this.setState({boardData:[]});
        //   }
        // })
      } else {
        if (!this.state.linkedProject) {
          message.error('No Project selected');
        } else if (!this.state.linkedIssue) {
          message.error('No Issue Selected');
        }
        this.setState({ error: error });
      }

      this.setState({ selectedStatuses: [], selectedResolutions: [] }, () => {
        this.updateEmojiMarkers();
      });
    } catch (error) {
      message.error('Something went wrong, please try again.');
      // console.error(error);
      this.props.history.push(
        `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${this.props.match.params.sub_skill}?view=channel_preferences`
      );
    }
  };

  saveChannelDefault = (data) => {
    const { channel_type } = this.state;
    data.channel = this.props.channel;
    data.channel_type = this.state.channel_type;
    this.props
      .setDefaultChannel(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        data,
        /*to handle "type" */ false,
        this.state.isGridSharedChannel
      )
      .then((res) => {
        this.setState({ tabView: false });
        if (res.data.success) {
          this.setState({ defaultloading: false });
          message.success('Saved successfully');
          this.setState({
            setFieldInputValue: res.data.link_info.link_info.issue_value,
            setFieldValueField: res.data.link_info.link_info.issue_field,
            linkedProject: res.data.link_info.link_info.project_id,
            linkedIssue:
              channel_type === 'support'
                ? res.data.link_info.link_info.requestType &&
                  res.data.link_info.link_info.requestType.name
                : res.data.link_info.link_info.issue_id,
            edit: false,
            error: {},
          });
          !res.data.link_info.link_info.board &&
            this.setState({ boardData: [] });
        }
      });
  };
  onClickDeleteConfirm = () => {
    Modal.confirm({
      title: 'Delete Channel defaults?',
      icon: <ExclamationCircleOutlined />,
      content: <p>Are you sure you want to delete channel defaults?</p>,
      onOk: () => this.onClickDelete(),
      onCancel: () => {},
    });
  };
  onClickDelete = () => {
    const { deleteDefaultChannel } = this.props;
    this.setState({ defaultloading: true });
    deleteDefaultChannel(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      this.props.channel.id,
      /*to handle "isPersonal"*/ false,
      this.state.isGridSharedChannel
    ).then((res) => {
      if (res.success) {
        message.success('Deleted successfully');
        this.setState({
          linkedProject: null,
          linkedIssue: null,
          board: '',
          linkedProjectName: '',
        });
        // this.props.history.push(`/${this.props.match.params.wId}/skills/${this.pro ps.match.params.skill_id}?view=channel_preferences`);
      } else {
        message.error('Error deleting channel defaults');
      }
      this.setState({ defaultloading: false });
    });
  };

  openEditState = async () => {
    this.setState({ edit: true });
    const { channelDefault } = this.props;
    if (this.props.channelDefault.link_info) {
      let query =
        'projectKeyOrId=' + this.props.channelDefault.link_info.project_id;
      await this.props
        .getJiraBoards(this.props.match.params.wId, query)
        .then((boardData) => {

          if (
            boardData &&
            boardData.data &&
            boardData.data.boards &&
            boardData.data.boards.length > 0 &&
            boardData.data.boards[0].name
          ) {
            this.setState({
              /*board: boardData.data.boards[0].name*/ boardData:
                boardData.data.boards,
            });
          } else this.setState({ boardData: [] });
        });
    }
  };

  onCancel = async () => {
    const { channel_type } = this.state;
    const { channelDefault } = this.props;
    if (this.props.channelDefault.link_info) {
      let query =
        'projectKeyOrId=' + this.props.channelDefault.link_info.project_id;
      await this.props
        .getJiraBoards(this.props.match.params.wId, query)
        .then((boardData) => {
          if (
            boardData &&
            boardData.data &&
            boardData.data.boards &&
            boardData.data.boards.length > 0 &&
            boardData.data.boards[0].name
          ) {
            this.setState({
              boardData: boardData.data.boards,
              board: channelDefault.link_info.board ? channelDefault.link_info.board.id.toString() : null
            });
          } else this.setState({ boardData: [],board: null });
        });
      this.props.getIssues(
        this.props.match.params.wId,
        channelDefault.link_info.project_id
      );
      this.setState({
        board: channelDefault.link_info.board
          ? channelDefault.link_info.board.id.toString()
          : channelDefault.link_info.board,
      });
    }

    if (channelDefault && channelDefault.link_info)
      this.setState({
        linkedProjectName: channelDefault.link_info.project_name,
        linkedProject: channelDefault.link_info.project_id,
        linkedIssue:
          channel_type === 'support'
            ? channelDefault.link_info.requestType &&
              channelDefault.link_info.requestType.name
            : channelDefault.link_info.issue_id,
      });
    else
      this.setState({
        linkedProjectName: '',
        linkedProject: null,
        linkedIssue: null,
        board: '',
        boardData: [],
      });
    this.setState({ edit: false, error: {} });

    this.setState({ fields: [] });

    // this.resetFieldDefaults_click_child()
  };

  toggleSetFieldValue = () => {
    this.setState({ setFieldValueModal: !this.state.setFieldValueModal });
  };

  toggleSetFieldValueCancel = () => {
    this.setState({
      setFieldValueField: '',
      setFieldInputField: '',
      setFieldValueModal: !this.state.setFieldValueModal,
    });
  };

  toggleSetFieldValueOk = () => {
    this.setState({ setFieldValueModal: !this.state.setFieldValueModal });
  };

  setFieldFieldValue = (event) => {
    // console.log('setFieldInputField',event)
    this.setState({ setFieldValueField: event });
  };

  setFieldInputValue = (event) => {
    // console.log('setFieldInputValue',event.target.value)
    this.setState({ setFieldInputField: event.target.value });
  };

  setFieldValueBody = () => {
    return (
      <div>
        <div>Jira Issue field</div>
        <div>
          <Select
            placeholder='Choose an field value'
            onChange={this.setFieldFieldValue}
            style={{ width: 472 }}
          >
            {setFieldValueValues.map((value) => (
              <Option key={value.value} value={value.value}>
                {value.label}
              </Option>
            ))}
          </Select>
        </div>
        <div>Issue Value</div>
        <div>
          <Input onChange={this.setFieldInputValue} />
        </div>
      </div>
    );
  };

  // showChannelSetting() {
  //   // let path = window.location.pathname;

  //   // let obj = {
  //   //   "title": this.props.skillView.view,
  //   //   "url": path + `?view=${this.props.skillView.view}`
  //   // }
  //   // // console.log(obj)
  //   // window.history.pushState(obj, obj.title, obj.url);

  //   this.props.history.push(`/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=channel_preferences`);

  //   this.setState({ showChannelSetting: true });
  // }

  getAdminNames = () => {
    let { currentChannelConfigs } = this.state;
    let adiminNames = '';
    if (currentChannelConfigs) {
      if (currentChannelConfigs.channel_admins.length > 0) {
        currentChannelConfigs.channel_admins.forEach((user, index) => {
          if (index < 3) {
            if (user) {
              const adminName =
                (user.user_id && user.user_id.displayName) ||
                (user.user_id && user.user_id.name) ||
                user.displayName ||
                user.name;
              adiminNames = adiminNames + (adminName || '');
            }
          }
        });
      }

      if (currentChannelConfigs.channel_admins.length > 3) {
        adiminNames =
          adiminNames +
          ` and ${currentChannelConfigs.channel_admins.length - 3} others`;
      }
    }

    return adiminNames;
  };

  getAvailableFields = (index) => {
    let allSelectedFields = [
      ...this.state.fieldsSelectedDetailed.map((config) => config.field),
    ];
    allSelectedFields.splice(index, 1);
    let allJiraFields = this.state.allFieldsInJira;
    allJiraFields = allJiraFields.filter(
      (field) =>
        !allSelectedFields.some(
          (selectedField) => selectedField.value === field.id
        )
    );
    return allJiraFields;
  };

  onDetailedFieldsSelect = (fieldName, type, index) => {
    // Type can be field or fallback.
    // Index gives attribute index.

    if (this.state.fieldsSelectedDetailed.length < 4)
      return message.error('Please try again.');
    let allSelectedFields = this.state.fieldsSelectedDetailed;
    let currentAttributeConfig = allSelectedFields[index];
    let field = this.state.allFieldsInJira.find(
      (field) => field.name === fieldName
    );
    currentAttributeConfig[type] = {
      index,
      name: field.name,
      value: field.id,
      schema: field.schema,
    };
    allSelectedFields[index] = currentAttributeConfig;

    let data = {
      showDescription: this.state.showDescription,
      fieldsSelectedDetailed: allSelectedFields,
      fieldSelectedCompact: this.state.fieldSelectedCompact,
    };
    this.handleIssueCardConfigChanges(data);

    // this.setState({
    //   fieldsSelectedDetailed: allSelectedFields
    // })
  };

  onCompactFieldsSelect = (fieldName) => {
    let selectedField = this.state.allFieldsInJira.find(
      (field) => field.name === fieldName
    );
    if (!selectedField) return message.error('Try again.');
    // this.setState({
    //   fieldSelectedCompact: selectedField
    // })
    selectedField = {
      field: {
        name: selectedField.name,
        value: selectedField.id,
        schema: selectedField.schema,
      },
      fallback: {
        name: 'Status',
        value: 'status',
      },
    };
    let data = {
      showDescription: this.state.showDescription,
      fieldsSelectedDetailed: this.state.fieldsSelectedDetailed,
      fieldSelectedCompact: selectedField,
    };
    this.handleIssueCardConfigChanges(data);
  };

  onReset = () => {
    let data = {
      showDescription: false,
      fieldsSelectedDetailed: defaultDetailedFields,
      fieldSelectedCompact: defaultCompactField,
    };
    this.handleIssueCardConfigChanges(data);
  };

  onViewChange = (id) => {
    this.setState({ currentView: id });
  };

  handleIssueCardConfigChanges = (data) => {
    // let data = {
    //   showDescription: this.state.showDescription,
    //   fieldsSelectedDetailed: this.state.fieldsSelectedDetailed
    // };
    let skill_id = this.props.match.params.skill_id;
    let channel_id = this.props.channel.id;
    let wId = this.props.match.params.wId;
    data = {
      issueCardCustomizationInfo: data,
    };
    axios
      // .post(`/bot/api/${wId}/issueCardCustomization/${skill_id}/channel/${channel_id}`, data)
      .post(
        `/bot/api/w/${wId}/jira/issueCardCustomization/${skill_id}/channel/${channel_id}`,
        data
      )
      .then((res) => {
        res = res.data;
        if (res && res.success) {
          let channelCommonData = res.channelCommonData;
          if (
            channelCommonData &&
            channelCommonData.issueCardCustomizationInfo
          ) {
            this.setState({
              showDescription:
                channelCommonData.issueCardCustomizationInfo.showDescription,
              fieldsSelectedDetailed:
                channelCommonData.issueCardCustomizationInfo
                  .fieldsSelectedDetailed,
              fieldSelectedCompact:
                channelCommonData.issueCardCustomizationInfo
                  .fieldSelectedCompact,
            });
          }
        }
      })
      .catch((error) => {
        message.error('Please try again.');
      });
  };

  on_CSAT_switch_change = (checked) => {
    let data = { ...this.props.channelDefault };

    if (data.link_info) {
      data.link_info.disable_CSAT_feedback = !checked;
      data.channel = this.props.channel;
      this.props
        .setDefaultChannel(
          this.props.match.params.wId,
          this.props.match.params.skill_id,
          data,
          /*to handle "type" */ false,
          this.state.isGridSharedChannel
        )
        .then((res) => {
          if (res.data.success) {
            this.setState({ disable_CSAT_feedback: !checked });
          } else message.error('Error updating Request CSAT feedback');
        });
    } else message.error('Channel defaults not set');
  };

  // onUnfurlChange = (checked) => {
  //   let data = { ...this.props.channelDefault };

  //   if (data.link_info) {
  //     data.link_info.disable_CSAT_feedback = !checked;
  //     data.channel=this.props.channel
  //     this.props
  //       .setDefaultChannel(this.props.match.params.skill_id, data, /*to handle "type" */ false, this.state.isGridSharedChannel)
  //       .then((res) => {
  //         if (res.data.success) {
  //           this.setState({ disable_CSAT_feedback: !checked });
  //         } else message.error("Error updating Request CSAT feedback");
  //       });
  //   } else message.error("Channel defaults not set");
  // };
  openModal = () => {
    this.setState({ remiderModal: !this.state.remiderModal });
  };

  onReminderTextChange = (e) => {
    this.setState({
      auto_remind: {
        ...this.state.auto_remind,
        [e.target.name]: e.target.value,
      },
    });
  };

  saveReminderConfig = () => {
    let data = { auto_remind: this.state.auto_remind };
    axios
      .post(
        // `/bot/api/${this.props.match.params.wId}/jira/${this.props.match.params.skill_id}/${this.props.channel.id}/updateautoticket?${query}`,
        `/bot/api/w/${this.props.match.params.wId}/jira/${this.props.match.params.skill_id}/${this.props.channel.id}/updateautoticket?${query}`,
        data
      )
      .then((res) => {
        // console.log(res.data)
        if (res.data && res.data.success /* &&res.data.warningMessage */) {
          // message.error("hi saurav what's up ")
          this.setState({ remiderModal: false });
        }
      });
  };

  HandleAutoCreateIssueTurnOnOff = async (value) => {
    this.onAutoCreateIssueChanged(value);

    // OLD LOGIC
    // let wikiConfigData = await this.props.getConfluenceChannelConfig(
    //   this.props.match.params.wId,
    //   this.props.channel.id
    // );
    // if (wikiConfigData.data.config) {
    //   this.setState({
    //     auto_suggest_in_wiki: wikiConfigData.data.config.auto_suggest,
    //   });
    // }

    // if (this.state.auto_suggest_in_wiki && value == 1) {
    //   Modal.confirm({
    //     title: 'Enable Auto Create?',
    //     icon: <ExclamationCircleOutlined />,
    //     content: (
    //       <p>
    //         Enabling auto create will disable auto suggestion of Confluence
    //         articles in this channel. Are you sure you want to enable this?
    //       </p>
    //     ),
    //     // onOk: () => this.setState({ auto_suggest: checked }, this.updateConfiguration),
    //     onOk: () => {
    //       this.props.addConfluenceChannelConfig(
    //         this.props.match.params.wId,
    //         {
    //           workspace_id: this.props.match.params.wId,
    //           channel: this.props.channel,
    //           spaces: [],
    //           skill_id: this.props.match.params.skill_id,
    //           auto_suggest: false,
    //         },
    //         false
    //       );
    //       this.onAutoCreateIssueChanged(value);
    //     },
    //     // onCancel: () => this.setState({ switchloading: false }),
    //   });
    // } else {
    //   this.onAutoCreateIssueChanged(value);
    // }
  };

  onAutoCreateIssueChanged = (value) => {
    let data = {};
    if (value === 0) {
      data = {
        auto_create_in_channel: false,
        auto_create_in_channel_emoji: false,
        auto_remind: {},
        auto_create_in_channel_unattended: false,
      };
    } else if (value === 1) {
      data = {
        auto_create_in_channel: true,
        auto_create_in_channel_emoji: false,
        auto_remind: {},
        auto_create_in_channel_unattended: false,
      };
    } else if (value === 2) {
      data = {
        auto_create_in_channel: false,
        auto_create_in_channel_emoji: true,
        auto_create_in_channel_unattended: false,
        auto_remind: {},
      };
    } else if (value === 3) {
      data = {
        auto_remind: {
          ...this.state.auto_remind,
          frequency: 0,
          isEnabled: true,
        },
        auto_create_in_channel: false,
        auto_create_in_channel_emoji: false,
        auto_create_in_channel_unattended: false,
      };
    } else if (value === 5) {
      data = {
        auto_create_in_channel: false,
        auto_create_in_channel_emoji: false,
        auto_remind: {},
        auto_create_in_channel_unattended: true,
      };
    } else if (value === 4) {
      data = {
        auto_remind: {
          ...this.state.auto_remind,
          frequency: 5,
          isEnabled: true,
        },
        auto_create_in_channel: false,
        auto_create_in_channel_emoji: false,
        auto_create_in_channel_unattended: false,
      };
    }

    let query = '';
    if (this.state.isGridSharedChannel) query = `isGridSharedChannel=true`;
    axios
      .post(
        // `/bot/api/${this.props.match.params.wId}/jira/${this.props.match.params.skill_id}/${this.props.channel.id}/updateautoticket?${query}`,
        `/bot/api/w/${this.props.match.params.wId}/jira/${this.props.match.params.skill_id}/${this.props.channel.id}/updateautoticket?${query}`,
        data
      )
      .then((res) => {
        // console.log(res.data)
        if (res.data && res.data.success /* &&res.data.warningMessage */) {
          // message.error("hi saurav what's up ")
          if (res.data.warningMessage) message.error(res.data.warningMessage);

          this.setState({
            auto_create_issue: data.auto_create_in_channel,
            auto_create_issue_emoji: data.auto_create_in_channel_emoji,
            auto_remind: data.auto_remind,
            auto_create_issue_unattended:
              data.auto_create_in_channel_unattended,
          });
        }
      });
  };

  switchButtonStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  };

  unfurlOptionsHandler = async (name) => {
    if (!name) return;

    let data = { channel: this.props.channel };
    data[name] = !this.state[name];
    let skill_id = this.props.match.params.skill_id;
    let channel_id = this.props.channel.id;
    let workspace_id = this.props.match.params.wId;

    // let link = `/bot/api/${workspace_id}/channel_config/${skill_id}/${channel_id}?isGridSharedChannel=${this.state.isGridSharedChannel}`;
    let link = `/bot/api/w/${workspace_id}/channelConfig/${skill_id}/${channel_id}?isGridSharedChannel=${this.state.isGridSharedChannel}`;
    let response = await axios.post(link, data);
    if (response) {
      this.setState({
        isUnfurl: response.data.commonChannelData.isUnfurl,
        isUnfurlLink: response.data.commonChannelData.isUnfurlLink,
        unfurlResponseInThread:
          response.data.commonChannelData.unfurlResponseInThread,
      });
    }
  };
  notifThreadParticipation = async () => {
    let data = {
      channel: this.props.channel,
      rejectThreadUsers: !this.state.rejectThreadUsers,
    };

    let skill_id = this.props.match.params.skill_id;
    let channel_id = this.props.channel.id;
    let workspace_id = this.props.match.params.wId;

    // let link = `/bot/api/${workspace_id}/channel_config/${skill_id}/${channel_id}?isGridSharedChannel=${this.state.isGridSharedChannel}`;
    let link = `/bot/api/w/${workspace_id}/channelConfig/${skill_id}/${channel_id}?isGridSharedChannel=${this.state.isGridSharedChannel}`;
    let response = await axios.post(link, data);
    if (response) {
      this.setState({ rejectThreadUsers: !this.state.rejectThreadUsers });
    }
    // await this.props.updateCommonChannelDataApi({rejectThreadUsers:!this.state.rejectThreadUsers})
  };

  threadParticationInfoModal = () => {
    Modal.info({
      title: 'Disable potential duplicate notifications',
      content: (
        <div>
          <p>
            Troopr sends notifications about ticket updates to all related
            parties including assignee, reporter & participants. This
            configuration allows you to disable such notifications if those
            people are already participants in Slack threads where the ticket is
            discussed in this channel.
          </p>
        </div>
      ),
      onOk() {},
    });
  };
  getHiddenFieldsCardText = () => {
    const { channelDefault } = this.props;

    let text;

    if (
      channelDefault &&
      channelDefault.link_info &&
      channelDefault.link_info.hiddenFields
    ) {
      let hiddenFields = { ...channelDefault.link_info.hiddenFields };
      text = (
        <Text type='secondary'>
          Hidden fields set for issue type(s){' '}
          <strong>{`${Object.keys(hiddenFields)[0]}${
            Object.keys(hiddenFields)[1]
              ? ', ' + Object.keys(hiddenFields)[1]
              : ''
          }`}</strong>{' '}
          {`${
            Object.keys(hiddenFields).length > 2
              ? `and ${Object.keys(hiddenFields).length - 2} more issue types.`
              : '.'
          }`}{' '}
          <br />
          <br />
          Click <strong>Hide Fields</strong> button above to cusomize field
          visibility when creating issues in this slack channel in the default
          project.
        </Text>
      );
    } else {
      text = (
        <Text type='secondary'>
          Click <strong>Hide Fields</strong> button above to cusomize field
          visibility when creating issues in this slack channel in the default
          project.
        </Text>
      );
    }

    return text;
  };

  deleteChannelConfiguration = (channel_id, name) => {
    const channelFound = this.props.channels.find(
      (channel) => channel.id === channel_id
    );
    let data = {
      channel_id,
      skill_id: this.props.match.params.skill_id,
    };
    data.isGridSharedChannel = false;
    if (
      channelFound &&
      channelFound.enterprise_id &&
      channelFound.is_org_shared
    )
      data.isGridSharedChannel = true;
    this.props
      .deleteChannelConfigurations(this.props.match.params.wId, data)
      .then((res) => {
        if (res.success) {
          message.success(`#${name} configurations deleted successfully`);
          this.props.history.push(
            `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${this.props.match.params.sub_skill}?view=channel_preferences`
          );
        }
      });
  };

  deleteConfiguration = (data) => {
    const { commonChanneldata, user_now, isWorkspaceAdimin } = this.props;
    let isChannelAdmin = true;
    const commondataFound = commonChanneldata.find(
      (channelCommonData) => channelCommonData.channel_id === data.id
    );

    if (
      commondataFound &&
      'restrict_channel_config' in commondataFound &&
      commondataFound.restrict_channel_config
    ) {
      const userFound =
        commondataFound &&
        commondataFound.channel_admins.find((user) => {
          const adminId = (user.user_id && user.user_id._id) || user.user_id;
          if (adminId) {
            return adminId.toString() === user_now._id.toString();
          }
        });
      if (userFound) isChannelAdmin = true;
      else isChannelAdmin = false;
    } else isChannelAdmin = true;

    if (isChannelAdmin || isWorkspaceAdimin) {
      return Modal.confirm({
        title: 'The following channel preferences will be reset',
        content:
          commondataFound && commondataFound.channel_type === 'support' ? (
            <>
              1. Request Defaults
              <br />
              2. Thread Sync behaviour
              <br />
              3. Channel administration
              <br />
              <br />
              This change is irreversible. Are you sure?
            </>
          ) : (
            <>
              1. Notification preferences
              <br />
              2. Issue Defaults
              <br />
              3. Thread Sync behaviour
              <br />
              4. Channel administration
              <br />
              <br />
              This change is irreversible. Are you sure?
            </>
          ),
        okText: 'Delete',
        okType: 'danger',
        onOk: () => this.deleteChannelConfiguration(data.id, data.name),
      });
    } else {
      message.warning(
        `Channel configuration access restricted. Contact one of the channel admins (or workspace admins) for access: ${this.getAdminNames(
          commondataFound
        )}`
      );
    }
  };

  col_span = 24;
  anchor_classname = localStorage.getItem('dark')
    ? 'anchor-links-dark'
    : 'anchor-links';

  defaults_menu = (
    <Menu
      onClick={(e) => {
        e.domEvent.stopPropagation();
      }}
    >
      <Menu.Item key='1' icon={<DeleteOutlined />}>
        Reset
      </Menu.Item>
    </Menu>
  );

  onSearch = (val) => {
    const { skills } = this.props;
    const { channel_id, channel_type } = queryString.parse(
      window.location.search
    );
    const jiraSkill = skills.find((skill) => skill.key === 'jira');
    if (
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.metadata &&
      (jiraSkill.skill_metadata.metadata.server_type === 'jira_cloud_oauth' ||
        jiraSkill.skill_metadata.metadata.server_type === 'jira_cloud') &&
      channel_type === 'project'
    ) {
      let query = `query=${val || ''}`;
      const queryType = '&typeKey=software,business';
      query = query + queryType;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.props.dropDownSearchJiraProjects(
          this.props.match.params.wId,
          `?query=${query}`
        );
      }, 300);
    }
  };

  handleEmojiMarker = (value) => {
    this.setState({ emojiMarkers: value }, this.updateEmojiMarkers);
  };

  handleEmojiMarkerDetails = (value, emojiType, status) => {
    this.setState(
      {
        emojiMarkersDetails: {
          ...this.state.emojiMarkersDetails,
          [emojiType]: {
            ...this.state.emojiMarkersDetails[emojiType],
            [status]: value,
          },
        },
      },
      this.updateEmojiMarkers
    );
  };

  handleChangeEmojiInAutoCreateDisableUsingEmoji = (emojiName) => {
    this.setState(
      (prevState) => ({
        openEmojiModal: false,
        auto_create_disable_if_message_with_emoji: {
          ...prevState.auto_create_disable_if_message_with_emoji,
          emoji: emojiName,
        },
      }),
      () => {
        this.props.channelAdminConfig(
          this.props.match.params.wId,
          this.props.match.params.skill_id,
          this.props.channel.id,
          {
            auto_create_disable_if_message_with_emoji: {
              isEnabled:
                this.state.auto_create_disable_if_message_with_emoji.isEnabled,
              emoji: this.state.auto_create_disable_if_message_with_emoji.emoji,
            },
          }
        );
      }
    );
  };

  handleChangeEmojiInReminderDisableUsingEmoji = (emojiName) => {
    this.setState(
      (prevState) => ({
        openReminderEmojiModal: false,
        reminder_disable_if_message_with_emoji: {
          ...prevState.reminder_disable_if_message_with_emoji,
          emoji: emojiName,
        },
      }),
      () => {
        this.props.channelAdminConfig(
          this.props.match.params.wId,
          this.props.match.params.skill_id,
          this.props.channel.id,
          {
            reminder_disable_if_message_with_emoji: {
              isEnabled:
                this.state.reminder_disable_if_message_with_emoji.isEnabled,
              emoji: this.state.reminder_disable_if_message_with_emoji.emoji,
            },
          }
        );
      }
    );
  };

  disableAutoCreateWithEmoji = async (value) => {
    this.setState(
      (prevState) => ({
        auto_create_disable_if_message_with_emoji: {
          ...prevState.auto_create_disable_if_message_with_emoji,
          isEnabled: value,
        },
      }),
      () => {
        this.props.channelAdminConfig(
          this.props.match.params.wId,
          this.props.match.params.skill_id,
          this.props.channel.id,
          {
            auto_create_disable_if_message_with_emoji: {
              isEnabled:
                this.state.auto_create_disable_if_message_with_emoji.isEnabled,
              emoji: this.state.auto_create_disable_if_message_with_emoji.emoji,
            },
          }
        );
      }
    );
  };

  disableSendReminderWithEmoji = async (value) => {
    this.setState(
      (prevState) => ({
        reminder_disable_if_message_with_emoji: {
          ...prevState.reminder_disable_if_message_with_emoji,
          isEnabled: value,
        },
      }),
      () => {
        this.props.channelAdminConfig(
          this.props.match.params.wId,
          this.props.match.params.skill_id,
          this.props.channel.id,
          {
            reminder_disable_if_message_with_emoji: {
              isEnabled:
                this.state.reminder_disable_if_message_with_emoji.isEnabled,
              emoji: this.state.reminder_disable_if_message_with_emoji.emoji,
            },
          }
        );
      }
    );
  };

  updateEmojiMarkers = () => {
    let query = '';
    const data = {
      emojiMarkers: this.state.emojiMarkers,
      emojiMarkersDetails: this.state.emojiMarkersDetails,
    };
    if (this.state.selectedDoneEmojiField) {
      data.selectedEmojiMarkerField = this.state.selectedDoneEmojiField;
    }
    if (this.state.selectedStatuses && this.state.allStatuses) {
      data.emojiMarkerStatuses = this.state.selectedStatuses.map(
        (selectedId) => {
          return this.state.allStatuses.find(
            (status) => status.id === selectedId
          );
        }
      );
    }

    if (this.state.selectedResolutions && this.state.allResolutions) {
      data.emojiMarkerResolutions = this.state.selectedResolutions.map(
        (selectedId) => {
          return this.state.allResolutions.find(
            (resoluton) => resoluton.id === selectedId
          );
        }
      );
    }

    if (this.state.isGridSharedChannel) query = `isGridSharedChannel=true`;
    axios
      .post(
        `/bot/api/w/${this.props.match.params.wId}/jira/${this.props.match.params.skill_id}/${this.props.channel.id}/channelConfig/updateEmojiMarker?${query}`,
        data
      )
      .then((res) => {
        // console.log(res.data)
        if (res.data && res.data.success /* &&res.data.warningMessage */) {
          if (res.data.channelConfig) {
            this.props.updateCommonChannelData(res.data.channelConfig);
          }
          // message.error("hi saurav what's up ")
          if (res.data.warningMessage) message.error(res.data.warningMessage);
          this.setState({
            emojiMarkers: data.emojiMarkers,
            emojiMarkersDetails: data.emojiMarkersDetails,
          });
        }
      });
  };

  handleRequestorAsReporter = (value) => {
    this.setState({ requestorAsReporter: value });
    this.props.channelAdminConfig(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      this.props.channel.id,
      {
        requestorAsReporter: value,
      }
    );
  };

  handleChangeEmojiMarkerFromOffHour = (disableAll) => {
    this.setState({
      ...(disableAll && { emojiMarkers: false }),
      emojiMarkersDetails: {
        ...this.state.emojiMarkersDetails,
        issueUnattended: {
          ...this.state.emojiMarkersDetails.issueUnattended,
          enabled: false,
        },
      },
    });
  };

  handleEnableAttribute = (value) => {
    this.setState({
      enableAttributeText: value,
    });
    this.props.channelAdminConfig(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      this.props.channel.id,
      {
        channelAttributionConfig: {
          enableAttributeText: value,
          ...(this.state.attributeText && {
            attributeText: this.state.attributeText,
          }),
        },
      }
    );
  };

  toggleChangeAttributeField = () => {
    this.setState({
      showAttributeTextField: !this.state.showAttributeTextField,
    });
    this.setState({ attributeText: this.state.attributeText });
  };

  cancelAttributeChange = () => {
    this.setState({
      showAttributeTextField: false,
      attributeText: this.props.skill.skill_metadata
        ? this.props.skill.skill_metadata.attributeText
        : this.props.skill.attributeText,
    });
  };

  resetAttributeText = async () => {
    this.props.channelAdminConfig(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      this.props.channel.id,
      {
        channelAttributionConfig: {
          enableAttributeText: true,
          attributeText: attributeText,
        },
      }
    );
    this.setState({
      attributeText: attributeText,
    });
  };

  saveAttributeTextChange = async () => {
    this.props.channelAdminConfig(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      this.props.channel.id,
      {
        channelAttributionConfig: {
          enableAttributeText: true,
          attributeText: this.state.attributeText,
        },
      }
    );
    this.toggleChangeAttributeField();
  };

  toggleChangeSummaryLength = () => {
    this.setState({
      showSummaryLengthInput: !this.state.showSummaryLengthInput,
    });
    this.setState({ summaryLength: this.state.summaryLength });
  };

  cancelSummaryLengthChange = () => {
    let channelSettings = this.props.commonChanneldata.find(
      (channel) => channel.channel_id === this.props.channel.id
    );
    this.setState({
      showSummaryLengthInput: false,
      summaryLength:
        (this.props.skill.skill_metadata
          ? this.props.skill.skill_metadata.summaryLength
          : this.props.skill.summaryLength) ||
        (channelSettings && channelSettings.summaryLength),
    });
  };

  saveSummaryLengthChange = async () => {
    this.props.channelAdminConfig(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      this.props.channel.id,
      {
        summaryLength: this.state.summaryLength,
      }
    );
    this.toggleChangeSummaryLength();
  };

  handleSaveSelectedStatuses = (value) => {
    const isStatusField = this.state.selectedDoneEmojiField === 'status';
    this.setState({
      selectedStatuses: isStatusField ? value : [],
      selectedResolutions: isStatusField ? [] : value,
    });
  };

  checkInCustomEmojis = (customEmojisFromSlack, emoji) => {
    if (customEmojisFromSlack[emoji])
      return (
        <img
          style={{
            width: '22px',
            height: '22px',
          }}
          src={customEmojisFromSlack[emoji]}
          alt=''
        />
      );
  };

  showStatusModal = () => {
    const { commonChanneldata } = this.props;
    const channelSettings = commonChanneldata.find(
      (channel) => channel.channel_id === this.props.channel.id
    );
    this.setState({
      selectedStatuses:
        channelSettings.emojiMarkerStatuses &&
        channelSettings.emojiMarkerStatuses.length > 0
          ? channelSettings.emojiMarkerStatuses.map((status) => status.id)
          : [],
      selectedResolutions:
        channelSettings.emojiMarkerResolutions &&
        channelSettings.emojiMarkerResolutions.length > 0
          ? channelSettings.emojiMarkerResolutions.map(
              (resolution) => resolution.id
            )
          : [],
    });
    this.setState({ openStatusModal: true });
  };

  handleSubmitStatusAndResolution = () => {
    this.updateEmojiMarkers();
    this.setState({ openStatusModal: false });
  };

  handleCloseStatusModal = () => {
    this.setState({ openStatusModal: false });
  };

  onFieldChange = (val) => {
    this.setState({ selectedDoneEmojiField: val });
    this.setState({ selectedStatuses: [], selectedResolutions: [] });
  };

  render() {
    const isEmojiMarkersEnabled =
      this.props.team &&
      this.props.team.scopeInfo &&
      this.props.team.scopeInfo.includes('reactions:write')
        ? true
        : false;
    const options =
      this.state.selectedDoneEmojiField === 'status'
        ? this.state.allStatuses
        : this.state.allResolutions;
    // let dataSourceForAttributesList = Array.apply(null, { length: this.state.numberOfFieldsInExpanded }).map((_, index) => {
    //   return {
    //     key: index,
    //   };
    // });

    // console.log("state from JiraChannelPreference",this.state);
    //  const search = window.location.search;
    //  const channelId = search.split('=')[2];
    const { sub_skill } = this.props.match.params;
    let {
      cardTemplates,
      projects,
      isWorkspaceAdimin,
      channelDefault,
      commonChanneldata,
      channel,
    } = this.props;

    const channelFound = commonChanneldata.find(
      (cha) => cha.channel_id == channel.id
    );
    const projectId =
      (this.props.channelDefault &&
        this.props.channelDefault.link_info &&
        (this.props.channelDefault.link_info.project_id ||
          this.props.channelDefault.link_info.project.id)) ||
      (channelFound &&
        channelFound.channel_linking_id &&
        channelFound.channel_linking_id.link_info &&
        channelFound.channel_linking_id.link_info.project.id);

    let {
      isChannelAdmin,
      currentChannelConfigs,
      linkedProject,
      projectLoading,
      channel_type,
      channelCommonData,
    } = this.state;

    let projectFound = false;
    if (linkedProject)
      projectFound = projects.find((project) =>
        channel_type === 'support'
          ? project.projectId
          : project.id == linkedProject
      );
    let qs = queryString.parse(window.location.search);
    let channel_data = {
      id: qs.channel_id,
      name: qs.channel_name,
    };

    let showRequestTypeFromRestriction = false;
    if (
      channelCommonData &&
      channelCommonData.requestTypeRestriction &&
      channelCommonData.requestTypeRestriction.find(
        (restriction) =>
          restriction.project.projectId === this.state.linkedProject
      )
    )
      showRequestTypeFromRestriction = true;

    const type_of_task = channel_type === 'support' ? 'request' : 'issue';
    const type_of_task_upper_case =
      channel_type === 'support' ? 'Request' : 'Issue';
    // else projectFound = false;
    return (
      <Layout style={{ marginLeft: 0 }}>
        {this.state.subscription ? (
          <Row
            className='main-content-padding'
            style={{
              marginBottom: '10vh',
              marginLeft: 0,
              marginRight: 0,
            }}
          >
            <Col span={20}>
              <Content>
                <IssueModal
                  channelId={this.props.channel.id}
                  channel_name={this.props.channel.name}
                  skill={this.props.skill}
                  setOption={this.props.setOption}
                  showModal={this.state.openIssueModal}
                  // closeModal={this.closeModal}
                  // projectId={this.state.projectId}
                  // projectName={this.state.projectName}
                  configureId={
                    this.state.subscription === 'isNew'
                      ? null
                      : this.state.subscription
                  }
                  isGridSharedChannel={this.state.isGridSharedChannel}
                />
              </Content>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col span={20}>
              <Content>
                <Row
                  style={{
                    marginBottom: '80vh',
                    marginLeft: 0,
                    marginRight: 0,
                  }}
                  gutter={this.props.global_row_gutter}
                  className='main-content-padding'
                >
                  {!this.state.showChannelSetting ? (
                    <div>
                      {/* <Title level={3} style={{ display: "flex" }}>  <Button
              onClick={this.showChannelSetting}
              icon={<ArrowLeftOutlined />}
              style={{ marginRight: "16px" }}
            >
              Back
        </Button>
              Channel: {this.state.currentChannelName} </Title> */}
                      {currentChannelConfigs != false &&
                        !isChannelAdmin &&
                        !isWorkspaceAdimin && (
                          <Col
                            span={this.col_span}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                          >
                            <Alert
                              showIcon
                              type='warning'
                              description={`Channel configuration access restricted. Contact one of the channel admins (or workspace admins) for access: ${this.getAdminNames()}`}
                              style={{ marginBottom: 8 }}
                            />
                          </Col>
                        )}
                      {!this.state.isTrooprAdded ? (
                        <Col
                          span={this.col_span}
                          style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                          <Alert
                            // description="Troopr is not invited to this channel. Features like Notifications, Reports, etc. will not work until Troopr is added. Use /invite @Troopr Assistant to invite Troopr to this channel."
                            message='Troopr is not invited to this channel. Features like Notifications, Reports, etc. will not work until Troopr is added. Use /invite @Troopr Assistant to invite Troopr to this channel.'
                            type='warning'
                            showIcon
                            style={{ marginBottom: 8 }}
                          />
                        </Col>
                      ) : null}

                      {this.state.showThreadSyncConfigurationInModal && (
                        <Modal
                          footer={[
                            <Button
                              key='close'
                              type='secondary'
                              onClick={() =>
                                this.setState({
                                  showThreadSyncConfigurationInModal: false,
                                })
                              }
                            >
                              Close
                            </Button>,
                          ]}
                          maskClosable={false}
                          title='Threadsync Configuration'
                          visible={true}
                          onOk={() =>
                            this.setState({
                              showThreadSyncConfigurationInModal: false,
                            })
                          }
                          onCancel={() =>
                            this.setState({
                              showThreadSyncConfigurationInModal: false,
                            })
                          }
                        >
                          <Text style={this.switchButtonStyle}>
                            Threadsync
                            <Switch
                              disabled={
                                !isChannelAdmin && !isWorkspaceAdimin
                                  ? true
                                  : false
                              } // If currentChannelConfig is not present, no need to disable.
                              checked={this.state.isThreadSync}
                              onChange={() => this.threadSyncToggle()}
                            />
                          </Text>
                          <Paragraph type='secondary'>
                            <p>
                              Jira {type_of_task} cards posted to this channel
                              will start a thread to continuously <br></br>sync
                              2-way with the corresponding Jira {type_of_task}.
                              Messages in this thread <br></br>will be added as
                              comments in Jira and vice versa. Every Jira{' '}
                              {type_of_task} can <br></br>have a maximum of 5
                              thread sync. Newer thread sync for the{' '}
                              {type_of_task} will automatically disable the
                              oldest one.
                            </p>
                          </Paragraph>
                          <br />

                          {/* <Radio.Group
                                options={threadsync_options}
                                disabled={!isChannelAdmin && !isWorkspaceAdimin ? true : false}
                                onChange={(event) => {
                                  let value = event.target.value;
                                  this.showAllUpdatesButtonToggle(value);
                                }}
                                value={this.state.update_type}
                                optionType='button'
                                buttonStyle='solid'
                              /> */}
                          <div>
                            <Text type='secondary'>
                              Only these Jira issue updates will be posted to
                              Slack thread.
                            </Text>
                          </div>
                          <br />
                          <Select
                            style={{ width: '100%' }}
                            disabled={
                              !isChannelAdmin && !isWorkspaceAdimin
                                ? true
                                : false
                            }
                            value={this.state.update_type}
                            placeholder='select a product'
                            onChange={this.showAllUpdatesButtonToggle}
                          >
                            {threadsync_options.map((o, key) => (
                              <Option key={key} value={o.value}>
                                {' '}
                                {o.label}{' '}
                              </Option>
                            ))}
                          </Select>
                        </Modal>
                      )}
                      <Row
                        /* className='content_row_jira' */ gutter={
                          this.props.global_row_gutter
                        }
                      >
                        <Col
                          span={this.col_span}
                          style={{ display: 'flex' }}
                          id='creation_behaviour'
                        >
                          <Card
                            title={`${type_of_task_upper_case} creation settings`}
                            style={{ width: '100%' }}
                          >
                            {this.state.tabView && (
                              <Modal
                                title='Channel Defaults'
                                visible={this.state.tabView}
                                maskClosable={false}
                                centered
                                onCancel={() => {
                                  this.setState({
                                    tabView: false,
                                  });
                                  this.onCancel();
                                }}
                                bodyStyle={{
                                  maxHeight: '70vh',
                                  overflowY: 'scroll',
                                  overflowX: 'hidden',
                                }}
                                footer={
                                  !(
                                    currentChannelConfigs != false &&
                                    !isChannelAdmin &&
                                    !isWorkspaceAdimin
                                  )
                                    ? [
                                        <>
                                          <Button
                                            key='submit'
                                            type='primary'
                                            // loading={this.state.loading}
                                            onClick={() => this.onClickSave()}
                                          >
                                            Save
                                          </Button>
                                        </>,
                                      ]
                                    : false
                                }
                              >
                                {this.state.loading ? (
                                  <Spin />
                                ) : (
                                  <div>
                                    {/* <Checkbox disabled={!this.state.edit} checked={isSupportChannel} onChange={this.onSupportChannelCheck} strong style={{marginBottom:8}}><Text type='secondary'>Is this a Support channel</Text></Checkbox> */}
                                    {channel_type === 'support' && (
                                      <>
                                        <Alert
                                          type='warning'
                                          style={{ textAlign: 'center' }}
                                          message='Channel defaults should be configured for ticketing task it'
                                        />
                                        <br />
                                      </>
                                    )}
                                    {/*------------------------------Default Project-----------------------------*/}
                                    <>
                                      <Text type='secondary' strong>
                                        Default Project
                                      </Text>
                                      <br />
                                      <Select
                                        name='linkedProject'
                                        style={{
                                          marginBottom: '8px',
                                          width: '100%',
                                        }}
                                        placeholder='Select Project'
                                        value={this.state.linkedProjectName}
                                        onChange={this.onChangeProject}
                                        showSearch={true}
                                        onSearch={this.onSearch}
                                        filterOption={(input, option) =>
                                          option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                        disabled={
                                          currentChannelConfigs != false &&
                                          !isChannelAdmin &&
                                          !isWorkspaceAdimin
                                        }
                                        loading={projectLoading}
                                      >
                                        {this.props.projects &&
                                          (channel_type === 'agent'
                                            ? this.props.projects.filter(
                                                (pro) =>
                                                  pro.projectTypeKey ===
                                                  'service_desk'
                                              )
                                            : channel_type === 'project'
                                            ? this.props.projects.filter(
                                                (pro) =>
                                                  pro.projectTypeKey ===
                                                    'software' ||
                                                  pro.projectTypeKey ===
                                                    'business'
                                              )
                                            : this.props.projects
                                          ).map((project, index) => {
                                            // let disabled = false
                                            // if(this.state.blockedProjects.find(p => (p.id || p.projectId) === (project.id || project.projectId )/*  || p.projectId === project.projectId */)) disabled = true
                                            return (
                                              <Option
                                                key={project.id}
                                                value={
                                                  channel_type === 'support'
                                                    ? project.projectId
                                                    : project.id
                                                } /* disabled={disabled} */
                                              >
                                                {channel_type === 'support'
                                                  ? project.projectName +
                                                    ` (${project.projectKey})`
                                                  : project.name +
                                                    ` (${project.key})`}
                                              </Option>
                                            );
                                          })}
                                      </Select>
                                      <br />

                                      {this.state.error.linkedProject && (
                                        <div className='error_message'>
                                          {this.state.error.linkedProject}
                                        </div>
                                      )}
                                    </>
                                    {/*---------------------------------Default Issue Type---------------------------*/}
                                    {/* <div className={this.state.linkedProject ? "bottom_space_forms" : "Preference_disable_state"}> */}
                                    <>
                                      <Text type='secondary' strong>
                                        {channel_type === 'support'
                                          ? 'Default Request Type (optional)'
                                          : 'Default Issue type'}
                                      </Text>
                                      <br />
                                      <Select
                                        // disabled={!this.state.linkedProject || !this.state.edit}
                                        name='linkedIssue'
                                        style={{
                                          marginBottom: '8px',
                                          width: '100%',
                                        }}
                                        value={this.state.linkedIssue}
                                        onChange={this.onChangeIssue}
                                        allowClear
                                        // disabled={projectFound ? false : true}
                                        disabled={
                                          projectFound
                                            ? currentChannelConfigs != false &&
                                              !isChannelAdmin &&
                                              !isWorkspaceAdimin
                                            : true
                                        }
                                        showSearch={true}
                                      >
                                        {/* {
                              channelCommonData && channelCommonData.requestTypeRestriction && channelCommonData.requestTypeRestriction.find(restriction => restriction.project.projectId === this.state.linkedProject) ?
                              <>
                                {channelCommonData.requestTypeRestriction.find(restriction => restriction.project.projectId === this.state.linkedProject).requestTypes.map((issue, index) => (
                                  <Option key={issue.value} value={issue.value}>
                                    {issue.text}
                                  </Option>
                                ))}
                              </>
                              :
                              <> */}

                                        {(showRequestTypeFromRestriction
                                          ? channelCommonData.requestTypeRestriction.find(
                                              (restriction) =>
                                                restriction.project
                                                  .projectId ===
                                                this.state.linkedProject
                                            ).requestTypes
                                          : this.props.issues &&
                                            this.props.issues
                                        ).map((issue, index) => (
                                          <Option
                                            key={issue.value}
                                            value={issue.value}
                                          >
                                            {issue.text}
                                          </Option>
                                        ))}
                                        {/* </>
                              } */}
                                      </Select>
                                      <br />
                                      {this.state.error.linkedIssue && (
                                        <div className='error_message'>
                                          {this.state.error.linkedIssue}
                                        </div>
                                      )}
                                    </>
                                    {/*------------------------------Board Def-----------------------------*/}
                                    {channel_type !== 'support' &&
                                      channel_type !== 'agent' && (
                                        <>
                                          <Text type='secondary' strong>
                                            {' '}
                                            Board (optional)
                                          </Text>
                                          <br />
                                          <Select
                                            name='boards'
                                            style={{
                                              width: '100%',
                                              marginBottom: '15px',
                                            }}
                                            showSearch={true}
                                            filterOption={(input, option) =>
                                              option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >=
                                              0
                                            }
                                            value={this.state.board}
                                            defaultValue={this.state.board}
                                            disabled={
                                              projectFound
                                                ? currentChannelConfigs !=
                                                    false &&
                                                  !isChannelAdmin &&
                                                  !isWorkspaceAdimin
                                                : true
                                            }
                                            onChange={this.onChangeBoard}
                                            allowClear
                                          >
                                            {this.state.boardData.map(
                                              (board) => {
                                                return (
                                                  <Option
                                                    value={board.id.toString()}
                                                    key={board.id.toString()}
                                                    label={board.name}
                                                  >
                                                    {board.name +
                                                      ` (${board.type})`}
                                                  </Option>
                                                );
                                              }
                                            )}
                                            {/* <Option value={this.state.board} >{this.state.board}</Option> */}
                                            {/* {cardTemplates && cardTemplates.map((board, index) => (
                            ))} */}
                                          </Select>
                                        </>
                                      )}

                                    {/*--------------------------------Set field value-----------------------*/}
                                    {/* <div className="d-flex flex-column">
                                  <div className="Jira_preference_personal_default_type">Set value as field</div>
                               <div>Jira Issue field</div>
                                <div>
                                   <Select 
                                      disabled={!this.state.edit}
                                      placeholder="Choose an field value"
                                      onChange={this.setFieldFieldValue}   
                                      style={{width : "100%"}} 
                                   >
                                   {setFieldValueValues.map(value => (
                                   <Option key={value.value} value={value.value}>
                                       {value.label}
                                   </Option>
                                 ))}
                                   </Select>
                                </div>
                                     <div>Issue Value</div>
                                      <div>
                                          <Input 
                                             disabled={!this.state.edit}
                                             style={{width:"100%"}}
                                             onChange={this.setFieldInputValue}/>
                                      </div>  
                              </div>*/}

                                    {(channel_type === 'project' ||
                                      channel_type === 'agent') &&
                                      this.state.linkedProject && (
                                        <JiraIssueFields
                                          issues={this.props.issues}
                                          // fields={this.state.fields}
                                          linkedIssue={this.state.linkedIssue}
                                          linkedProject={
                                            this.state.linkedProject
                                          }
                                          updateChannelDefaultData={
                                            this.state.updateChannelDefaultData
                                          }
                                          saveChannelDefault={(data) =>
                                            this.saveChannelDefault(data)
                                          }
                                          setClick={(click) =>
                                            (this.clickChild = click)
                                          }
                                          channelDefault={
                                            this.props.channelDefault
                                          }
                                          board={this.state.board}
                                          disableEdit={
                                            currentChannelConfigs != false &&
                                            !isChannelAdmin &&
                                            !isWorkspaceAdimin
                                          }
                                          tabView={this.state.tabView}
                                          // project_change={(click) => (this.project_change_click_child = click)}
                                          /* issue_change={(click) => (this.issue_change_click_child = click)}  resetFieldDefaults={(click) =>
             (this.resetFieldDefaults_click_child = click)
                     } */
                                          // resetFieldDefaults={(click) =>
                                          //   (this.resetFieldDefaults_click_child = click)}
                                        />
                                      )}

                                    {/*---------------------------------Buttons---------------------------------------*/}
                                    {/* {(currentChannelConfigs == false || isChannelAdmin || isWorkspaceAdimin) && this.props.channelDefault.channel_id &&!this.state.edit && <Button  type='danger' style={{float:'right',width:'114px'}} loading={this.state.defaultloading} onClick={this.onClickDeleteConfirm}>Delete</Button>} */}
                                    {/* {(currentChannelConfigs == false || isChannelAdmin || isWorkspaceAdimin) && <div>{this.state.edit ?
                      <div >
                        <Button style={{width:'114px'}} onClick={this.onCancel}>Cancel</Button>
                        <Button type="primary" style={{width:'114px',marginLeft:'10px'}} loading={this.state.defaultloading} onClick={this.onClickSave}>Save</Button>
                      </div>
                       : 
                       <div>
                         <Button style={{width:'114px'}}  onClick={this.openEditState}>Edit</Button>
                      {this.props.channelDefault.channel_id && <Button  type='danger' style={{float:'right',width:'114px'}} loading={this.state.defaultloading} onClick={this.onClickDeleteConfirm}>Delete</Button>}

                       </div>
                       }
                       </div>} */}
                                  </div>
                                )}
                              </Modal>
                            )}
                            <div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <div>
                                  <div>
                                    <Text strong>Creation Defaults: </Text>
                                    <Text type='secondary'>
                                      Set defaults for {type_of_task} creation
                                      in this channel
                                    </Text>
                                  </div>
                                  <br />
                                  {this.state.loading ? (
                                    <Spin />
                                  ) : (
                                    <>
                                      {channelDefault.channel_id ? (
                                        <>
                                          <Text type='secondary'>
                                            Project:{' '}
                                          </Text>{' '}
                                          {
                                            channelDefault.link_info
                                              .project_name
                                          }{' '}
                                          <br />
                                          <Text type='secondary'>
                                            {channel_type === 'support'
                                              ? 'Request Type:'
                                              : 'Issue Type:'}{' '}
                                          </Text>{' '}
                                          {channel_type === 'support'
                                            ? channelDefault.link_info
                                                .requestType
                                              ? channelDefault.link_info
                                                  .requestType.name
                                              : ''
                                            : channelDefault.link_info
                                                .issue_id}{' '}
                                          <br />
                                          {channelDefault.link_info.board && (
                                            <>
                                              <Text type='secondary'>
                                                Board:{' '}
                                              </Text>{' '}
                                              {
                                                channelDefault.link_info.board
                                                  .name
                                              }{' '}
                                              &nbsp;
                                              <Tooltip
                                                title={
                                                  <>
                                                    Board Default is used only
                                                    during issue listing in this
                                                    channel
                                                  </>
                                                }
                                              >
                                                <QuestionCircleOutlined size='small' />
                                              </Tooltip>
                                              <br />
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <Text type='secondary'>
                                          No defaults set. Click Manage button
                                          to set defaults.
                                        </Text>
                                      )}
                                    </>
                                  )}
                                </div>
                                <div>
                                  {(currentChannelConfigs == false ||
                                    isChannelAdmin ||
                                    isWorkspaceAdimin) &&
                                  this.props.channelDefault.channel_id ? (
                                    <Dropdown.Button
                                      overlay={
                                        <>
                                          <Menu
                                            onClick={this.onClickDeleteConfirm}
                                          >
                                            <Menu.Item key='1'>
                                              <DeleteOutlined /> Clear Defaults
                                            </Menu.Item>
                                          </Menu>
                                        </>
                                      }
                                      onClick={() => {
                                        this.setState({
                                          tabView: 'manage',
                                        });
                                      }}
                                    >
                                      Manage
                                    </Dropdown.Button>
                                  ) : (
                                    <Button
                                      onClick={() => {
                                        this.setState({
                                          tabView: 'manage',
                                        });
                                      }}
                                    >
                                      Manage
                                    </Button>
                                  )}
                                </div>
                              </div>
                              <Divider />
                              {(channel_type === 'project' ||
                                channel_type === 'agent') && (
                                <div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <div>
                                      <Text>
                                        <strong>Field defaults: </strong>
                                      </Text>
                                      <Text type='secondary'>
                                        Set default values for fields in{' '}
                                        {type_of_task} creation form (in default
                                        project)
                                      </Text>
                                    </div>
                                    <div>
                                      <Button
                                        onClick={() => {
                                          this.setState({
                                            tabView: 'fieldDefaults',
                                          });
                                        }}
                                      >
                                        Update Field Defaults
                                      </Button>
                                    </div>
                                  </div>
                                  <div style={{ width: '80%' }}>
                                    {channelDefault &&
                                    channelDefault.link_info &&
                                    channelDefault.link_info.fieldDefaults ? (
                                      <>
                                        <Text type='secondary'>
                                          Field defaults set for issue type(s){' '}
                                          {Object.keys(
                                            channelDefault.link_info
                                              .fieldDefaults
                                          ).map((issue_type, index) => {
                                            if (
                                              index ===
                                              Object.keys(
                                                channelDefault.link_info
                                                  .fieldDefaults
                                              ).length -
                                                1
                                            )
                                              return `${
                                                Object.keys(
                                                  channelDefault.link_info
                                                    .fieldDefaults
                                                ).length === 1
                                                  ? ''
                                                  : 'and'
                                              } ${issue_type}`;
                                            else
                                              return `${issue_type}${
                                                Object.keys(
                                                  channelDefault.link_info
                                                    .fieldDefaults
                                                ).length -
                                                  2 ===
                                                index
                                                  ? ''
                                                  : ','
                                              } `;
                                          })}
                                          . Click{' '}
                                          <strong>Update Field Defaults</strong>{' '}
                                          button for details.
                                        </Text>
                                        <br />
                                      </>
                                    ) : (
                                      <Text type='secondary'>
                                        Click{' '}
                                        <strong>Update Field Defaults</strong>{' '}
                                        button to customize field defaults
                                      </Text>
                                    )}
                                  </div>
                                  <Divider />
                                </div>
                              )}
                              {(channel_type === 'project' ||
                                channel_type === 'agent') && (
                                <div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'space-between',
                                      // marginBottom: 16,
                                    }}
                                  >
                                    <div>
                                      <Text>
                                        <strong>Hide field: </strong>
                                      </Text>
                                      <Text type='secondary'>
                                        Hide fields in {type_of_task} creation
                                        form (in default project)
                                      </Text>
                                    </div>
                                    <div>
                                      <Button
                                        onClick={() => {
                                          this.setState({
                                            tabView: 'hideFields',
                                          });
                                        }}
                                      >
                                        Hide Fields
                                      </Button>
                                    </div>
                                  </div>
                                  <div style={{ width: '80%' }}>
                                    {this.getHiddenFieldsCardText()}
                                  </div>
                                  <Divider />
                                </div>
                              )}

                              {channel_type === 'support' && (
                                <>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'space-between',
                                      marginBottom: 8,
                                    }}
                                  >
                                    <div style={{ marginRight: 16 }}>
                                      <Text>
                                        <strong>Guest facilitation: </strong>
                                      </Text>
                                      <Text type='secondary'>
                                        {/* <a
                                        onClick={() => {
                                          Modal.info({
                                            title: "Guest facilitation scenarios",
                                            content: (
                                              <div>
                                                <p>Guest facilitation will be triggered in the following scenarios</p>
                                                <p>
                                                  1. When auto create issues is enabled and unverified users post messages in the channel or add the
                                                  issue creation emoji to a message in the channel
                                                </p>
                                                <p>2. When thread sync is enabled and an unverified user posts message in the thread</p>
                                              </div>
                                            ),
                                          });
                                        }}
                                      >
                                        In guest facilitation scenarios
                                      </a> */}
                                        Troopr can facilitate Jira actions for
                                        users who have not verified their Jira
                                        account yet. This feature can be
                                        activated by authorizing a facilitator
                                        account below.
                                      </Text>
                                    </div>
                                    <div>
                                      {!(
                                        currentChannelConfigs &&
                                        currentChannelConfigs.guestToken
                                      ) && (
                                        <Button
                                          onClick={() =>
                                            this.goToUserJiraLogin()
                                          }
                                        >
                                          Authorize
                                        </Button>
                                      )}
                                      {currentChannelConfigs &&
                                        currentChannelConfigs.guestToken && (
                                          <>
                                            <Button
                                              danger
                                              onClick={
                                                this
                                                  .removeGuestAuthorizationConfirm
                                              }
                                            >
                                              Remove Authorization
                                            </Button>
                                          </>
                                        )}
                                    </div>
                                  </div>
                                  <div>
                                    {currentChannelConfigs &&
                                      currentChannelConfigs.guestToken &&
                                      currentChannelConfigs.guestToken
                                        .user_obj && (
                                        <Text>
                                          Facilitator account:{' '}
                                          {currentChannelConfigs.guestToken
                                            .user_obj.displayName ||
                                            currentChannelConfigs.guestToken
                                              .user_obj.name ||
                                            currentChannelConfigs.guestToken
                                              .user_obj.emailAddress}
                                        </Text>
                                      )}{' '}
                                  </div>
                                  {currentChannelConfigs &&
                                    currentChannelConfigs.guestToken && (
                                      <>
                                        <Divider />
                                        <GlobalGuestUserRestriction
                                          forChannelGuestTokenRestriction
                                          currentChannelConfigs={
                                            this.state.currentChannelConfigs
                                          }
                                          isGridSharedChannel={
                                            this.state.isGridSharedChannel
                                          }
                                        />
                                      </>
                                    )}
                                  <Divider />
                                </>
                              )}

                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <div>
                                  <Text>
                                    <strong>Auto Assign: </strong>
                                  </Text>
                                  <Text type='secondary'>
                                    When creating {type_of_task} from channel,
                                    auto-assign the creator as the assignee for
                                    that {type_of_task}
                                  </Text>
                                </div>
                                <div>
                                  <Switch
                                    disabled={
                                      (!isChannelAdmin && !isWorkspaceAdimin) ||
                                      !this.props.channelDefault.link_info
                                    }
                                    checked={this.state.creatorAsAssignee}
                                    onChange={() =>
                                      this.creatorAsAssigneeChange()
                                    }
                                  />
                                </div>
                              </div>
                              <Divider />
                              <div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    marginBottom: 12,
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>Auto create:</strong>
                                    </Text>
                                    <Text type='secondary'>
                                      {' '}
                                      Automatically create a new {
                                        type_of_task
                                      }{' '}
                                      for every message posted{' '}
                                      {this.props.channelDefault.link_info &&
                                        channel_type === 'support' &&
                                        !this.props.channelDefault.link_info
                                          .requestType && (
                                          <>
                                            <Text type='secondary'>
                                              (Request Type must be configured)
                                            </Text>
                                          </>
                                        )}
                                    </Text>
                                  </div>
                                  <div>
                                    <Switch
                                      onChange={() =>
                                        this.HandleAutoCreateIssueTurnOnOff(
                                          this.state.auto_create_issue ||
                                            this.state
                                              .auto_create_issue_emoji ||
                                            this.state
                                              .auto_create_issue_unattended ||
                                            (this.state.auto_remind &&
                                              this.state.auto_remind
                                                .frequency >= 0)
                                            ? 0
                                            : 1
                                        )
                                      }
                                      checked={
                                        this.state.auto_create_issue ||
                                        this.state.auto_create_issue_emoji ||
                                        this.state
                                          .auto_create_issue_unattended ||
                                        (this.state.auto_remind &&
                                          this.state.auto_remind.frequency >= 0)
                                      }
                                      disabled={
                                        (!isChannelAdmin &&
                                          !isWorkspaceAdimin) ||
                                        !this.props.channelDefault.link_info ||
                                        (this.props.channelDefault.link_info &&
                                          channel_type === 'support' &&
                                          !this.props.channelDefault.link_info
                                            .requestType)
                                      }
                                    />
                                  </div>
                                </div>
                                {(this.state.auto_create_issue ||
                                  this.state.auto_create_issue_emoji ||
                                  this.state.auto_create_issue_unattended ||
                                  (this.state.auto_remind &&
                                    this.state.auto_remind.frequency >= 0)) && (
                                  <>
                                    <Radio.Group
                                      value={
                                        this.state.auto_create_issue
                                          ? 1
                                          : this.state.auto_create_issue_emoji
                                          ? 2
                                          : this.state
                                              .auto_create_issue_unattended
                                          ? 5
                                          : this.state.auto_remind
                                          ? this.state.auto_remind.frequency ===
                                            0
                                            ? 3
                                            : this.state.auto_remind
                                                .frequency === 5
                                            ? 4
                                            : 0
                                          : 0
                                      }
                                      onChange={(e) =>
                                        this.onAutoCreateIssueChanged(
                                          e.target.value
                                        )
                                      }
                                      disabled={
                                        this.state.currentChannelConfigs
                                          ? !isChannelAdmin
                                          : false
                                      }
                                    >
                                      <Space direction='vertical'>
                                        <Radio value={1}>
                                          For every message posted
                                        </Radio>
                                        {(channelCommonData.restrict_channel_config
                                          ? isChannelAdmin
                                          : true) && (
                                          <div>
                                            {this.state.auto_create_issue && (
                                              <Checkbox
                                                style={{ paddingLeft: 20 }}
                                                checked={
                                                  this.state
                                                    .auto_create_disable_if_message_with_emoji
                                                    .isEnabled
                                                }
                                                onChange={(value) => {
                                                  this.disableAutoCreateWithEmoji(
                                                    value.target.checked
                                                  );
                                                }}
                                                disabled={
                                                  (!isChannelAdmin &&
                                                    !isWorkspaceAdimin) ||
                                                  !this.state.auto_create_issue
                                                }
                                              >
                                                Disable auto-create when message
                                                starts with{' '}
                                                {
                                                  channelCommonData.restrict_channel_config
                                                }
                                                {emojis[
                                                  this.state
                                                    .auto_create_disable_if_message_with_emoji
                                                    .emoji
                                                ] ||
                                                  (this.state
                                                    .customEmojisFromSlack[
                                                    this.state
                                                      .auto_create_disable_if_message_with_emoji
                                                      .emoji
                                                  ] ? (
                                                    <img
                                                      style={{
                                                        width: '22px',
                                                        height: '22px',
                                                      }}
                                                      src={
                                                        this.state
                                                          .customEmojisFromSlack[
                                                          this.state
                                                            .auto_create_disable_if_message_with_emoji
                                                            .emoji
                                                        ]
                                                      }
                                                      alt=''
                                                    />
                                                  ) : (
                                                    ''
                                                  ))}{' '}
                                                emoji
                                              </Checkbox>
                                            )}
                                            {this.state
                                              .auto_create_disable_if_message_with_emoji
                                              .isEnabled &&
                                              this.state.auto_create_issue && (
                                                <Button
                                                  disabled={
                                                    !this.state
                                                      .auto_create_disable_if_message_with_emoji
                                                      .isEnabled ||
                                                    !(
                                                      isChannelAdmin ||
                                                      isWorkspaceAdimin
                                                    )
                                                  }
                                                  style={{ paddingLeft: 1 }}
                                                  type='link'
                                                  onClick={() => {
                                                    this.setState({
                                                      openEmojiModal: true,
                                                    });
                                                  }}
                                                >
                                                  {' '}
                                                  (change emoji)
                                                </Button>
                                              )}{' '}
                                            {this.state.openEmojiModal && (
                                              <EmojiPicker
                                                handleClick={(el) => {
                                                  // console.log(el.name)
                                                  this.handleChangeEmojiInAutoCreateDisableUsingEmoji(
                                                    el.name
                                                  );
                                                }}
                                                customEmojisFromSlack={
                                                  this.state
                                                    .customEmojisFromSlack
                                                }
                                                closePicker={() => {
                                                  this.setState({
                                                    openEmojiModal: false,
                                                  });
                                                }}
                                              />
                                            )}
                                          </div>
                                        )}
                                        {/* <Radio value={2}>On issue creation emoji</Radio> */}
                                        <Radio value={2}>
                                          On any “Emoji action” for{' '}
                                          {type_of_task} creation <br /> *This
                                          configuration will override the
                                          creation settings configured in the
                                          “emoji action”. See list of emoji
                                          actions{' '}
                                          <Typography.Link
                                            onClick={() =>
                                              this.props.history.push(
                                                `/${this.props.match.params.wId}/emoji_actions`
                                              )
                                            }
                                          >
                                            here
                                          </Typography.Link>
                                          .
                                        </Radio>
                                        <Radio value={5}>
                                          Auto create {type_of_task} when
                                          unattended (no response in 5 mins)
                                        </Radio>
                                        <Radio value={3}>
                                          Send Reminder to create {type_of_task}
                                          .{' '}
                                          {this.state.auto_remind &&
                                            this.state.auto_remind.frequency ===
                                              0 && (
                                              <Button
                                                disabled={
                                                  !isChannelAdmin &&
                                                  !isWorkspaceAdimin
                                                    ? true
                                                    : false
                                                }
                                                style={{ padding: 0 }}
                                                type='link'
                                                onClick={this.openModal}
                                              >
                                                Customize message
                                              </Button>
                                            )}
                                        </Radio>
                                        {(channelCommonData.restrict_channel_config
                                          ? isChannelAdmin
                                          : true) && (
                                          <div>
                                            {this.state.auto_remind &&
                                              this.state.auto_remind
                                                .frequency === 0 && (
                                                <Checkbox
                                                  style={{ paddingLeft: 20 }}
                                                  checked={
                                                    this.state
                                                      .reminder_disable_if_message_with_emoji
                                                      .isEnabled
                                                  }
                                                  onChange={(value) => {
                                                    this.disableSendReminderWithEmoji(
                                                      value.target.checked
                                                    );
                                                  }}
                                                  disabled={
                                                    (!isChannelAdmin &&
                                                      !isWorkspaceAdimin) ||
                                                    !(
                                                      this.state.auto_remind &&
                                                      this.state.auto_remind
                                                        .frequency === 0
                                                    )
                                                  }
                                                >
                                                  Disable reminder when message
                                                  starts with{' '}
                                                  {
                                                    channelCommonData.restrict_channel_config
                                                  }
                                                  {emojis[
                                                    this.state
                                                      .reminder_disable_if_message_with_emoji
                                                      .emoji
                                                  ] ||
                                                    (this.state
                                                      .customEmojisFromSlack[
                                                      this.state
                                                        .reminder_disable_if_message_with_emoji
                                                        .emoji
                                                    ] ? (
                                                      <img
                                                        style={{
                                                          width: '22px',
                                                          height: '22px',
                                                        }}
                                                        src={
                                                          this.state
                                                            .customEmojisFromSlack[
                                                            this.state
                                                              .reminder_disable_if_message_with_emoji
                                                              .emoji
                                                          ]
                                                        }
                                                        alt=''
                                                      />
                                                    ) : (
                                                      ''
                                                    ))}{' '}
                                                  emoji
                                                </Checkbox>
                                              )}
                                            {this.state
                                              .reminder_disable_if_message_with_emoji
                                              .isEnabled &&
                                              this.state.auto_remind &&
                                              this.state.auto_remind
                                                .frequency === 0 && (
                                                <Button
                                                  disabled={
                                                    !this.state
                                                      .reminder_disable_if_message_with_emoji
                                                      .isEnabled ||
                                                    !(
                                                      isChannelAdmin ||
                                                      isWorkspaceAdimin
                                                    )
                                                  }
                                                  style={{ paddingLeft: 1 }}
                                                  type='link'
                                                  onClick={() => {
                                                    this.setState({
                                                      openReminderEmojiModal: true,
                                                    });
                                                  }}
                                                >
                                                  {' '}
                                                  (change emoji)
                                                </Button>
                                              )}{' '}
                                            {this.state
                                              .openReminderEmojiModal && (
                                              <EmojiPicker
                                                handleClick={(el) => {
                                                  // console.log(el.name)
                                                  this.handleChangeEmojiInReminderDisableUsingEmoji(
                                                    el.name
                                                  );
                                                }}
                                                customEmojisFromSlack={
                                                  this.state
                                                    .customEmojisFromSlack
                                                }
                                                closePicker={() => {
                                                  this.setState({
                                                    openReminderEmojiModal: false,
                                                  });
                                                }}
                                              />
                                            )}
                                          </div>
                                        )}

                                        {/* <Radio value={4}>Send Reminder to create {type_of_task} when unattended(no response in 5 mins){(this.state.auto_remind.frequency===5)&& <Button style={{padding: 0}} type="link" onClick={this.openModal}>Customize message</Button> }
                                  </Radio> */}

                                        <Modal
                                          title={
                                            <>
                                              <EditOutlined
                                                style={{ marginRight: '15px' }}
                                              />
                                              Customize the reminder message
                                            </>
                                          }
                                          closable={false}
                                          okText={'Customize'}
                                          visible={this.state.remiderModal}
                                          onOk={this.saveReminderConfig}
                                          onCancel={this.openModal}
                                        >
                                          Reminder Text
                                          <Input
                                            placeholder='Enter reminder text'
                                            onChange={this.onReminderTextChange}
                                            name={'messageText'}
                                            value={
                                              this.state.auto_remind &&
                                              this.state.auto_remind
                                                .messageText &&
                                              this.state.auto_remind.messageText
                                            }
                                          />
                                          <br />
                                          <br />
                                          {type_of_task
                                            .charAt(0)
                                            .toUpperCase() +
                                            type_of_task.slice(1)}{' '}
                                          Creation Button Text
                                          {/* `➕ ${type_of_task}` */}
                                          <Input
                                            placeholder='Enter button name'
                                            onChange={this.onReminderTextChange}
                                            name={'buttonText'}
                                            maxLength={30}
                                            value={
                                              this.state.auto_remind &&
                                              this.state.auto_remind
                                                .buttonText &&
                                              this.state.auto_remind.buttonText
                                            }
                                          />
                                        </Modal>
                                      </Space>
                                    </Radio.Group>
                                    <br />
                                    <br />

                                    <Text type='warning'>
                                      Automatic {type_of_task} creation in this
                                      channel will work only when "summary" is
                                      the only mandatory field in the default{' '}
                                      {type_of_task} type.
                                    </Text>
                                    <br />
                                    <br />

                                    {this.state.isUnfurl &&
                                      !this.state.auto_create_issue_emoji &&
                                      !this.state
                                        .auto_create_issue_unattended && (
                                        <Text type='warning'>
                                          This feature will automatically
                                          disable '{type_of_task} Preview
                                          (Unfurl)' in this channel
                                        </Text>
                                      )}
                                  </>
                                )}

                                {/* <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    marginBottom: 8
                                  }}>
                                  <div>
                                  <Text>
                                    <strong>Auto create:</strong>
                                  </Text>
                                    <Text type="secondary"> When unattended for 5min
                                    </Text>
                                  </div>
                                  <div style={{float:"right"}}>
                                    <Switch onChange={(value)=>{this.handleUnattendedmessge(value)}} checked={this.state.auto_create_issue_unattended}
                                    />
                                  </div>
                                </div> */}
                                <Divider />
                                <ProjectRestriction
                                  userChannels={this.props.userChannels}
                                  isChannelAdmin={this.state.isChannelAdmin}
                                />
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>Auto start thread sync:</strong>
                                    </Text>
                                    <Text type='secondary'>
                                      {' '}
                                      This will automatically start thread sync
                                      during {type_of_task} creation and{' '}
                                      {type_of_task} preview
                                    </Text>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !isChannelAdmin && !isWorkspaceAdimin
                                          ? true
                                          : false
                                      } // If currentChannelConfig is not present, no need to disable.
                                      checked={this.state.isThreadSync}
                                      onChange={() => this.threadSyncToggle()}
                                    />
                                  </div>
                                </div>
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>Requestor as Reporter: </strong>
                                    </Text>
                                    {channel_type === 'support' ? (
                                      <Text type='secondary'>
                                        When converting a Slack message to Jira
                                        request, Troopr will try to make the
                                        user who posted the Slack message as the
                                        reporter. When that is not possible,
                                        Troopr will fallback to request creator
                                        as reporter. Disabling this feature will
                                        make request creator as reporter always.
                                      </Text>
                                    ) : (
                                      <Text type='secondary'>
                                        When converting a Slack message to Jira
                                        issue, Troopr will try to make the user
                                        who posted the Slack message as the
                                        reporter. When that is not possible,
                                        Troopr will fallback to issue creator as
                                        reporter. Disabling this feature will
                                        make issue creator as reporter always.
                                      </Text>
                                    )}
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !isChannelAdmin && !isWorkspaceAdimin
                                          ? true
                                          : false
                                      } // If currentChannelConfig is not present, no need to disable.
                                      checked={this.state.requestorAsReporter}
                                      onChange={(event) =>
                                        this.handleRequestorAsReporter(event)
                                      }
                                    />
                                  </div>
                                </div>
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div style={{ marginRight: 8 }}>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text>
                                        <strong>Attribution: </strong>
                                      </Text>
                                      <Text type='secondary'>{`When a Jira issue is created in Slack channel, Troopr will add this attribution text to the bottom of issue description. (Max length 256)`}</Text>
                                    </div>
                                    {!this.state.showAttributeTextField && (
                                      <div>
                                        <Text type='secondary' italic>
                                          {this.state.attributeText
                                            ? this.state.attributeText
                                            : attributeText}
                                        </Text>
                                      </div>
                                    )}
                                    {this.state.showAttributeTextField && (
                                      <div>
                                        {' '}
                                        <Input
                                          maxLength={256}
                                          onChange={(e) =>
                                            this.setState({
                                              attributeText: e.target.value,
                                            })
                                          }
                                          value={this.state.attributeText}
                                        ></Input>
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        display: 'flex',
                                        marginTop: 16,
                                        columnGap: 16,
                                        rowGap: 8,
                                      }}
                                    >
                                      <Button
                                        disabled={
                                          this.state.attributeText == '' ||
                                          !this.state.enableAttributeText
                                        }
                                        onClick={() =>
                                          this.state.showAttributeTextField
                                            ? this.saveAttributeTextChange()
                                            : this.toggleChangeAttributeField()
                                        }
                                      >
                                        {this.state.showAttributeTextField
                                          ? 'Save'
                                          : 'Change Text'}
                                      </Button>

                                      {this.state.showAttributeTextField && (
                                        <Button
                                          onClick={() =>
                                            this.cancelAttributeChange()
                                          }
                                        >
                                          Cancel
                                        </Button>
                                      )}

                                      {!this.state.showAttributeTextField &&
                                        this.state.attributeText &&
                                        this.state.attributeText !==
                                          attributeText && (
                                          <Button
                                            onClick={() =>
                                              this.resetAttributeText()
                                            }
                                          >
                                            Reset Text
                                          </Button>
                                        )}
                                    </div>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !isChannelAdmin && !isWorkspaceAdimin
                                      }
                                      checked={this.state.enableAttributeText}
                                      onChange={(event) =>
                                        this.handleEnableAttribute(event)
                                      }
                                    />
                                  </div>
                                </div>
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>Truncate Summary: </strong>
                                    </Text>
                                    <Text type='secondary'>{`Set Jira ticket summary length when creating from Slack channel. (Max length 250 characters)`}</Text>
                                  </div>
                                  <InputNumber
                                    min={20}
                                    max={250}
                                    value={this.state.summaryLength}
                                    onChange={(value) =>
                                      this.setState({
                                        summaryLength: value,
                                      })
                                    }
                                    style={{ maxWidth: 150 }}
                                    disabled={
                                      !this.state.showSummaryLengthInput
                                    }
                                  />
                                  <div
                                    style={{
                                      display: 'flex',
                                      gap: '8px',
                                      minWidth: '150px',
                                    }}
                                  >
                                    <Button
                                      disabled={!this.state.summaryLength}
                                      onClick={() =>
                                        this.state.showSummaryLengthInput
                                          ? this.saveSummaryLengthChange()
                                          : this.toggleChangeSummaryLength()
                                      }
                                    >
                                      {this.state.showSummaryLengthInput
                                        ? 'Save'
                                        : 'Change Length'}
                                    </Button>

                                    {this.state.showSummaryLengthInput && (
                                      <Button
                                        onClick={() =>
                                          this.cancelSummaryLengthChange()
                                        }
                                      >
                                        Cancel
                                      </Button>
                                    )}
                                  </div>
                                </div>
                                {channelCommonData &&
                                  channelCommonData.is_private && (
                                    <>
                                      <br />
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          justifyContent: 'space-between',
                                        }}
                                      >
                                        <div>
                                          <Text>
                                            <strong>
                                              Enable user name for private
                                              channel:{' '}
                                            </strong>
                                          </Text>
                                          <Text type='secondary'>
                                            User name will be shared in
                                            atribution text even in private
                                            channel
                                          </Text>
                                        </div>
                                        <div>
                                          <Switch
                                            disabled={
                                              !isChannelAdmin &&
                                              !isWorkspaceAdimin
                                                ? true
                                                : false
                                            } // If currentChannelConfig is not present, no need to disable.
                                            checked={
                                              channelCommonData &&
                                              channelCommonData.show_user_name_in_private_channel
                                            }
                                            onChange={(value) =>
                                              this.updateCommondata(
                                                'show_user_name_in_private_channel',
                                                !value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                              </div>
                              {channel_type === 'support' && (
                                <>
                                  <Divider />
                                  <RequestTypeRestriction
                                    channelLevel={true}
                                    isChannelAdmin={this.state.isChannelAdmin}
                                    channelCommonData={
                                      this.state.channelCommonData
                                    }
                                  />
                                </>
                              )}

                              {this.state.isRequestTypeRestrictionsEnabled ? (
                                <>
                                  <div style={{ marginBottom: 8 }}>
                                    <div style={{ marginBottom: 8 }}>
                                      <Radio.Group
                                        name='radiogroup'
                                        defaultValue={1}
                                      >
                                        <Radio value={1}>
                                          Block Selected Request Types
                                        </Radio>
                                        <Radio value={2}>
                                          Allow Selected Request Types
                                        </Radio>
                                      </Radio.Group>
                                    </div>
                                    <div>
                                      <Select
                                        style={{ width: 300 }}
                                        defaultValue={['1', '2']}
                                        mode='multiple'
                                      >
                                        <Option value='1'>RequestType1</Option>
                                        <Option value='2'>RequestType2</Option>
                                        <Option value='3'>RequestType3</Option>
                                        <Option value='4'>RequestType4</Option>
                                        <Option value='5'>RequestType5</Option>
                                      </Select>
                                    </div>
                                  </div>
                                  <div>
                                    <Button>Edit</Button>
                                  </div>
                                </>
                              ) : (
                                ''
                              )}
                            </div>
                          </Card>
                        </Col>

                        {channel_type === 'support' && (
                          <Col span={this.col_span} id='off-hour-settings'>
                            <OffHourSetting
                              handleChangeEmojiMarkerFromOffHour={
                                this.handleChangeEmojiMarkerFromOffHour
                              }
                            />
                          </Col>
                        )}

                        {this.state.emojiOpenedBy && (
                          <Modal
                            closable={false}
                            visible={this.state.emojiOpenedBy}
                            maskClosable={false}
                            onCancel={() => {
                              this.setState({ emojiOpenedBy: false });
                            }}
                            destroyOnClose={true}
                            //   onOk={handleCustomFilterModalOk}
                          >
                            <EmojiPicker
                              customEmojisFromSlack={
                                this.state.customEmojisFromSlack
                              }
                              selectedEmoji={
                                this.state.emojiMarkersDetails[
                                  this.state.emojiOpenedBy
                                ].emoji
                              }
                              closePicker={() => {
                                this.setState({ emojiOpenedBy: '' });
                              }}
                              handleClick={(el) => {
                                this.handleEmojiMarkerDetails(
                                  el.name,
                                  this.state.emojiOpenedBy,
                                  'emoji'
                                );
                                this.setState({ emojiOpenedBy: '' });
                              }}
                            />
                          </Modal>
                        )}

                        {isEmojiMarkersEnabled && (
                          <Col span={this.col_span} id='emojiMarkers'>
                            <Card
                              title={
                                <>
                                  <Text>Emoji Markers</Text>
                                  <Button
                                    type='link'
                                    style={{ marginLeft: 4 }}
                                    onClick={() => {
                                      Modal.info({
                                        title: 'Emoji markers scope',
                                        content: (
                                          <Text>
                                            Emoji markers work on Slack messages
                                            that are converted to Jira issues in
                                            thread. Emoji markers for "issue
                                            assign" trigger and issue "marked as
                                            done" trigger also work on
                                            notification messages with real time
                                            thread sync enabled.
                                          </Text>
                                        ),
                                      });
                                    }}
                                  >
                                    Where does this apply?
                                  </Button>
                                </>
                              }
                              extra={
                                <Switch
                                  disabled={
                                    !isChannelAdmin && !isWorkspaceAdimin
                                  }
                                  checked={this.state.emojiMarkers}
                                  onChange={this.handleEmojiMarker}
                                />
                              }
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 8,
                                }}
                              >
                                <div>
                                  <Text type='secondary'>
                                    Add emojis to the Slack message based on
                                    specific criteria
                                  </Text>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    Add{' '}
                                    {emojis[
                                      this.state.emojiMarkersDetails
                                        .issueCreated.emoji
                                    ] ||
                                      this.checkInCustomEmojis(
                                        this.state.customEmojisFromSlack,
                                        this.state.emojiMarkersDetails
                                          .issueCreated.emoji
                                      )}
                                    emoji (
                                    <a
                                      onClick={() => {
                                        if (
                                          !this.state.emojiMarkers ||
                                          (!isChannelAdmin &&
                                            !isWorkspaceAdimin) ||
                                          !this.state.emojiMarkersDetails
                                            .issueCreated.enabled
                                        ) {
                                          return;
                                        }
                                        this.setState({
                                          emojiOpenedBy: 'issueCreated',
                                        });
                                      }}
                                      disabled={
                                        !this.state.emojiMarkers ||
                                        !(
                                          isChannelAdmin || isWorkspaceAdimin
                                        ) ||
                                        !this.state.emojiMarkersDetails
                                          .issueCreated.enabled
                                      }
                                    >
                                      change emoji
                                    </a>
                                    ) when a new issue corresponding to the
                                    message is created
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !this.state.emojiMarkers ||
                                        (!isChannelAdmin && !isWorkspaceAdimin)
                                      }
                                      checked={
                                        this.state.emojiMarkersDetails
                                          .issueCreated.enabled
                                      }
                                      onChange={(value) =>
                                        this.handleEmojiMarkerDetails(
                                          value,
                                          'issueCreated',
                                          'enabled'
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                    }}
                                  >
                                    <div>
                                      Add{' '}
                                      {emojis[
                                        this.state.emojiMarkersDetails.issueDone
                                          .emoji
                                      ] ||
                                        this.checkInCustomEmojis(
                                          this.state.customEmojisFromSlack,
                                          this.state.emojiMarkersDetails
                                            .issueDone.emoji
                                        )}{' '}
                                      emoji (
                                      <a
                                        onClick={() => {
                                          if (
                                            !this.state.emojiMarkers ||
                                            (!isChannelAdmin &&
                                              !isWorkspaceAdimin) ||
                                            !this.state.emojiMarkersDetails
                                              .issueDone.enabled
                                          ) {
                                            return;
                                          }
                                          this.setState({
                                            emojiOpenedBy: 'issueDone',
                                          });
                                        }}
                                        disabled={
                                          !this.state.emojiMarkers ||
                                          !(
                                            isChannelAdmin || isWorkspaceAdimin
                                          ) ||
                                          !this.state.emojiMarkersDetails
                                            .issueDone.enabled
                                        }
                                      >
                                        change emoji
                                      </a>
                                      ) when the status or resolution of the
                                      issue corresponding to the message is set
                                      here :
                                    </div>
                                    <div>
                                      <Button
                                        type='link'
                                        onClick={this.showStatusModal}
                                        size='small'
                                        disabled={
                                          !this.state.emojiMarkersDetails
                                            .issueDone.enabled
                                        }
                                        style={{
                                          width: 100,
                                        }}
                                      >
                                        Set field
                                      </Button>
                                      <Modal
                                        title='Select Status or Resolution'
                                        visible={this.state.openStatusModal}
                                        onOk={
                                          this.handleSubmitStatusAndResolution
                                        }
                                        onCancel={this.handleCloseStatusModal}
                                      >
                                        <div
                                          style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px',
                                          }}
                                        >
                                          <Text> Select field</Text>
                                          <Select
                                            onChange={(e) =>
                                              this.onFieldChange(e)
                                            }
                                            value={
                                              this.state.selectedDoneEmojiField
                                            }
                                            options={[
                                              {
                                                value: 'resolution',
                                                label: 'Resolution',
                                              },
                                              {
                                                value: 'status',
                                                label: 'Status',
                                              },
                                            ]}
                                          />
                                        </div>
                                        <div
                                          style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px',
                                            marginTop: '8px',
                                          }}
                                        >
                                          <Text>
                                            {' '}
                                            {`Select ${this.state.selectedDoneEmojiField}`}
                                          </Text>
                                          <Select
                                            mode='multiple'
                                            style={{ width: '100%' }}
                                            id={`input_select_${this.state.selectedDoneEmojiField}`}
                                            placeholder={`Choose ${this.state.selectedDoneEmojiField}`}
                                            value={
                                              this.state
                                                .selectedDoneEmojiField ===
                                              'status'
                                                ? this.state.selectedStatuses
                                                : this.state.selectedResolutions
                                            }
                                            maxTagCount={'responsive'}
                                            onChange={
                                              this.handleSaveSelectedStatuses
                                            }
                                            disabled={!projectId}
                                            filterOption={(input, option) =>
                                              option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >=
                                              0
                                            }
                                          >
                                            {options &&
                                              options.length > 0 &&
                                              options.map((item) => (
                                                <Option
                                                  key={item.id}
                                                  name={item.name}
                                                  value={item.id}
                                                >
                                                  {item.name}
                                                </Option>
                                              ))}
                                          </Select>
                                        </div>
                                      </Modal>
                                    </div>
                                    {/* {this.state.emojiMarkersDetails.issueDone
                                      .enabled && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          padding: '0 2rem 0 1rem',
                                          minWidth: '250px',
                                          flexDirection: 'column',
                                        }}
                                      >
                                        <Select
                                          mode='multiple'
                                          style={{ width: '100%' }}
                                          size='small'
                                          id='input_select_status'
                                          placeholder='Select Status'
                                          value={this.state.selectedStatuses}
                                          maxTagCount={'responsive'}
                                          onChange={
                                            this.handleSaveSelectedStatuses
                                          }
                                          disabled={!projectId}
                                          filterOption={(input, option) =>
                                            option.props.children
                                              .toLowerCase()
                                              .indexOf(input.toLowerCase()) >= 0
                                          }
                                        >
                                          {this.state.allStatuses &&
                                            this.state.allStatuses.length > 0 &&
                                            this.state.allStatuses.map(
                                              (status) => (
                                                <Option
                                                  key={status.id}
                                                  name={status.name}
                                                  value={status.id}
                                                >
                                                  {status.name}
                                                </Option>
                                              )
                                            )}
                                        </Select>
                                        {!projectId && (
                                          <Text
                                            type='danger'
                                            style={{ fontSize: '12px' }}
                                          >
                                            *Set the creation defaults
                                          </Text>
                                        )}
                                      </div>
                                    )} */}
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !this.state.emojiMarkers ||
                                        (!isChannelAdmin && !isWorkspaceAdimin)
                                      }
                                      checked={
                                        this.state.emojiMarkersDetails.issueDone
                                          .enabled
                                      }
                                      onChange={(value) =>
                                        this.handleEmojiMarkerDetails(
                                          value,
                                          'issueDone',
                                          'enabled'
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    Add{' '}
                                    {emojis[
                                      this.state.emojiMarkersDetails
                                        .issueAssigned.emoji
                                    ] ||
                                      this.checkInCustomEmojis(
                                        this.state.customEmojisFromSlack,
                                        this.state.emojiMarkersDetails
                                          .issueAssigned.emoji
                                      )}{' '}
                                    emoji (
                                    <a
                                      onClick={() => {
                                        if (
                                          !this.state.emojiMarkers ||
                                          (!isChannelAdmin &&
                                            !isWorkspaceAdimin) ||
                                          !this.state.emojiMarkersDetails
                                            .issueAssigned.enabled
                                        ) {
                                          return;
                                        }
                                        this.setState({
                                          emojiOpenedBy: 'issueAssigned',
                                        });
                                      }}
                                      disabled={
                                        !this.state.emojiMarkers ||
                                        !(
                                          isChannelAdmin || isWorkspaceAdimin
                                        ) ||
                                        !this.state.emojiMarkersDetails
                                          .issueAssigned.enabled
                                      }
                                    >
                                      change emoji
                                    </a>
                                    ) when the issue corresponding to the
                                    message is assigned
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !this.state.emojiMarkers ||
                                        (!isChannelAdmin && !isWorkspaceAdimin)
                                      }
                                      checked={
                                        this.state.emojiMarkersDetails
                                          .issueAssigned.enabled
                                      }
                                      onChange={(value) =>
                                        this.handleEmojiMarkerDetails(
                                          value,
                                          'issueAssigned',
                                          'enabled'
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      Add{' '}
                                      {emojis[
                                        this.state.emojiMarkersDetails
                                          .issueUnattended.emoji
                                      ] ||
                                        this.checkInCustomEmojis(
                                          this.state.customEmojisFromSlack,
                                          this.state.emojiMarkersDetails
                                            .issueUnattended.emoji
                                        )}{' '}
                                      emoji (
                                      <a
                                        onClick={() => {
                                          if (
                                            !this.state.emojiMarkers ||
                                            (!isChannelAdmin &&
                                              !isWorkspaceAdimin) ||
                                            !this.state.emojiMarkersDetails
                                              .issueUnattended.enabled
                                          ) {
                                            return;
                                          }
                                          this.setState({
                                            emojiOpenedBy: 'issueUnattended',
                                          });
                                        }}
                                        disabled={
                                          !this.state.emojiMarkers ||
                                          !(
                                            isChannelAdmin || isWorkspaceAdimin
                                          ) ||
                                          !this.state.emojiMarkersDetails
                                            .issueUnattended.enabled
                                        }
                                      >
                                        change emoji
                                      </a>
                                      ) when the message is unattended for 5
                                      minutes
                                    </Text>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !this.state.emojiMarkers ||
                                        (!isChannelAdmin && !isWorkspaceAdimin)
                                      }
                                      checked={
                                        this.state.emojiMarkersDetails
                                          .issueUnattended.enabled
                                      }
                                      onChange={(value) =>
                                        this.handleEmojiMarkerDetails(
                                          value,
                                          'issueUnattended',
                                          'enabled'
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </Card>
                          </Col>
                        )}

                        {channel_type === 'agent' && (
                          <Col span={this.col_span} id='internal-comments'>
                            <InternalComment />
                          </Col>
                        )}

                        {(channel_type === 'project' ||
                          channel_type === 'agent') && (
                          <Col span={this.col_span} id='notifications'>
                            <Subscriptions
                              channel={this.props.channel}
                              isChannelAdmin={this.state.isChannelAdmin}
                              isWorkspaceAdimin={isWorkspaceAdimin}
                              currentChannelConfigs={
                                this.state.currentChannelConfigs
                              }
                              channel_type={channel_type}
                              userChannels={this.props.userChannels}
                              isGridSharedChannel={
                                this.state.isGridSharedChannel
                              }
                            />
                          </Col>
                        )}
                        {(channel_type === 'project' ||
                          channel_type === 'agent') && (
                          <Col span={this.col_span} id='thread_participation'>
                            <Card>
                              <div className='d-flex justify-content-between align-items-center '>
                                <div
                                  style={{ fontWeight: 600 }}
                                  className='d-flex  align-items-center '
                                >
                                  Notify only when not a thread participant
                                  <a
                                    onClick={this.threadParticationInfoModal}
                                    style={{ marginLeft: '12px' }}
                                  >
                                    <InfoCircleOutlined />
                                  </a>
                                </div>

                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <Switch
                                    checked={this.state.rejectThreadUsers}
                                    disabled={
                                      !isChannelAdmin && !isWorkspaceAdimin
                                    }
                                    onChange={() =>
                                      this.notifThreadParticipation()
                                    }
                                  />
                                </div>
                              </div>
                            </Card>
                          </Col>
                        )}

                        {(channel_type === 'project' ||
                          channel_type === 'agent') &&
                          (this.state.isChannelAdmin ||
                            this.props.isWorkspaceAdimin) && (
                            <Col span={this.col_span} id='issue_card'>
                              <Card
                                title='Issue card customization'
                                extra={
                                  <Button
                                    type='primary'
                                    disabled={
                                      !isChannelAdmin && !isWorkspaceAdimin
                                    }
                                    onClick={() =>
                                      this.setState({
                                        showIssueCardCustomizationModal: true,
                                      })
                                    }
                                  >
                                    Customize
                                  </Button>
                                }
                              >
                                {this.state.showIssueCardCustomizationModal && (
                                  <IssueCardCustomizationInfo
                                    close={() =>
                                      this.setState({
                                        showIssueCardCustomizationModal: false,
                                      })
                                    }
                                    customizationIn='channels'
                                    open={
                                      this.state.showIssueCardCustomizationModal
                                    }
                                  />
                                )}
                                <Text type='secondary'>
                                  Customize how Troopr will show Jira issues in
                                  Slack.
                                </Text>
                              </Card>
                              {/* <IssueCardCustomization
                              projectId={this.state.linkedProject}
                              linkedIssue={this.state.linkedIssue}
                              channelAdmin={this.state.isChannelAdmin}
                              workspaceAdmin={this.props.isWorkspaceAdimin}
                            />{' '} */}
                            </Col>
                          )}
                        {(channel_type === 'project' ||
                          channel_type === 'agent') &&
                          (this.state.isChannelAdmin ||
                            this.props.isWorkspaceAdimin) && (
                            <Col span={this.col_span} id='issue_card'>
                              <Card
                                title='Issue view customization'
                                extra={
                                  <Button
                                    type='primary'
                                    disabled={
                                      !isChannelAdmin && !isWorkspaceAdimin
                                    }
                                    onClick={() =>
                                      this.setState({
                                        showViewCardCustomizationModal: true,
                                      })
                                    }
                                  >
                                    Customize
                                  </Button>
                                }
                              >
                                {this.state.showViewCardCustomizationModal && (
                                  <ViewCardCustomization
                                    close={() =>
                                      this.setState({
                                        showViewCardCustomizationModal: false,
                                      })
                                    }
                                    customizationIn='channels'
                                    commonChannelConfig={
                                      this.props.commonChanneldata
                                    }
                                    open={
                                      this.state.showViewCardCustomizationModal
                                    }
                                    isGridSharedChannel={
                                      this.state.isGridSharedChannel
                                    }
                                  />
                                )}
                                <Text type='secondary'>
                                  Customize how Troopr will show issue details
                                  when viewing issue details in Slack
                                </Text>
                              </Card>
                              {/* <IssueCardCustomization
                              projectId={this.state.linkedProject}
                              linkedIssue={this.state.linkedIssue}
                              channelAdmin={this.state.isChannelAdmin}
                              workspaceAdmin={this.props.isWorkspaceAdimin}
                            />{' '} */}
                            </Col>
                          )}
                        <Col span={this.col_span} id='unfurl'>
                          <Card
                            title={
                              channel_type === 'support'
                                ? 'Request Preview (Unfurl)'
                                : 'Issue Preview (Unfurl)'
                            }
                            key='0'
                            extra={
                              sub_skill !== 'jira_software' && (
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <Switch
                                    checked={this.state.isUnfurl}
                                    disabled={
                                      !isChannelAdmin && !isWorkspaceAdimin
                                    }
                                    onChange={() =>
                                      this.unfurlOptionsHandler('isUnfurl')
                                    }
                                  />
                                </div>
                              )
                            }
                          >
                            <Text type='secondary'>
                              Show additional information about Jira{' '}
                              {type_of_task} when its is mentioned in Slack
                            </Text>
                            <br />
                            {(this.state.auto_create_issue ||
                              this.state.auto_create_issue_unattended ||
                              (this.state.auto_remind &&
                                this.state.auto_remind.frequency >= 0)) && (
                              <Text type='warning'>
                                Note that unfurl will not work if ‘Auto Create{' '}
                                {type_of_task}’ is enabled in this channel.
                              </Text>
                            )}
                            {sub_skill === 'jira_software' && (
                              <>
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>Override:</strong>{' '}
                                    </Text>
                                    <Text type='secondary'>
                                      Override the default global behaviour
                                    </Text>
                                  </div>

                                  <div>
                                    <Switch
                                      checked={this.state.isUnfurl}
                                      disabled={
                                        !isChannelAdmin && !isWorkspaceAdimin
                                      }
                                      onChange={() =>
                                        this.unfurlOptionsHandler('isUnfurl')
                                      }
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            {(this.state.isUnfurl ||
                              sub_skill !== 'jira_software') && (
                              <>
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>Link Preview:</strong>{' '}
                                    </Text>
                                    <Text type='secondary'>
                                      Allow Troopr to generate {type_of_task}{' '}
                                      preview for Jira {type_of_task}
                                      links. Example:
                                      https://acme.atlassian.net/servicedesk/customer/portal/1/SD-1230
                                    </Text>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !this.state.isUnfurl || !isChannelAdmin
                                      }
                                      checked={this.state.isUnfurlLink}
                                      onChange={() =>
                                        this.unfurlOptionsHandler(
                                          'isUnfurlLink'
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>Preview in Thread:</strong>{' '}
                                    </Text>
                                    <Text type='secondary'>
                                      Expanded {type_of_task} context will be
                                      sent as Slack messsage in the original
                                      message thread.
                                    </Text>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !this.state.isUnfurl || !isChannelAdmin
                                      }
                                      checked={
                                        this.state.unfurlResponseInThread
                                      }
                                      onChange={() =>
                                        this.unfurlOptionsHandler(
                                          'unfurlResponseInThread'
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>Auto start thread sync:</strong>
                                    </Text>
                                    <Text type='secondary'>
                                      {' '}
                                      This will automatically start thread sync
                                      during {type_of_task} creation and{' '}
                                      {type_of_task} preview
                                    </Text>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={
                                        !isChannelAdmin && !isWorkspaceAdimin
                                          ? true
                                          : false
                                      } // If currentChannelConfig is not present, no need to disable.
                                      checked={this.state.isThreadSync}
                                      onChange={() => this.threadSyncToggle()}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </Card>
                        </Col>

                        <Col span={this.col_span} id='threadsync'>
                          <Card
                            title={
                              <>
                                <Text>Jira to Slack thread sync condition</Text>
                                <Button
                                  type='link'
                                  style={{ marginLeft: 4 }}
                                  onClick={() => {
                                    Modal.info({
                                      title: 'Thread sync condition scope',
                                      content: (
                                        <Text>
                                          These filter condition is applicable
                                          to thread sync started during issue
                                          preview, message action, emoji action
                                          or when a user manually starts thread
                                          sync in a Troopr issue card in Slack.
                                          <br />
                                          <br />
                                          Note that the filter condition is NOT
                                          application for thread sync started by
                                          a notification subscription,
                                          corresponding notification filters
                                          will apply.
                                        </Text>
                                      ),
                                    });
                                  }}
                                >
                                  Where does this apply?
                                </Button>
                              </>
                            }
                            key='2'
                            // extra={
                            //   <div
                            //     onClick={(e) => {
                            //       e.stopPropagation();
                            //     }}
                            //   >
                            //     <Switch
                            //       disabled={!isChannelAdmin && !isWorkspaceAdimin ? true : false} // If currentChannelConfig is not present, no need to disable.
                            //       checked={this.state.isThreadSync}
                            //       onChange={() => this.threadSyncToggle()}
                            //     />
                            //   </div>
                            // }
                          >
                            {/* <Text type='secondary'>
                            Jira {type_of_task} messages in this channel will start a thread to continuously sync 2-way with the corresponding Jira{" "}
                            {type_of_task}. New messages in this thread will be added as comments in Jira and vice versa.
                          </Text> */}

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div>
                                <Text type='secondary'>
                                  Only these Jira issue updates will be posted
                                  to Slack thread.
                                </Text>
                              </div>
                              <div style={{ width: '20%', marginLeft: '24px' }}>
                                {/* <Radio.Group
                                options={threadsync_options}
                                disabled={!isChannelAdmin && !isWorkspaceAdimin ? true : false}
                                onChange={(event) => {
                                  let value = event.target.value;
                                  this.showAllUpdatesButtonToggle(value);
                                }}
                                value={this.state.update_type}
                                optionType='button'
                                buttonStyle='solid'
                              /> */}

                                <Select
                                  style={{ width: '100%' }}
                                  disabled={
                                    !isChannelAdmin && !isWorkspaceAdimin
                                      ? true
                                      : false
                                  }
                                  value={this.state.update_type}
                                  placeholder='select a product'
                                  onChange={this.showAllUpdatesButtonToggle}
                                >
                                  {threadsync_options.map((o, key) => (
                                    <Option key={key} value={o.value}>
                                      {' '}
                                      {o.label}{' '}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>
                            {/* {channel_type !== 'support' && (
                              <div>
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>Leading message:</strong>{' '}
                                    </Text>
                                    <Text type='secondary'>
                                      Troopr posts the first message in the
                                      thread with information about how to
                                      customize thread sync behaviour
                                    </Text>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={!isChannelAdmin}
                                      checked={
                                        !this.state.disableLeadingMessage
                                      }
                                      onChange={(checked) =>
                                        this.threadSyncConfigs(
                                          'disableLeadingMessage',
                                          checked
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <Divider />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div>
                                    <Text>
                                      <strong>At-mention reporter:</strong>{' '}
                                    </Text>
                                    <Text type='secondary'>
                                      At-mention reporter in the thread if they
                                      don't already follow the thread{' '}
                                    </Text>
                                  </div>
                                  <div>
                                    <Switch
                                      disabled={!isChannelAdmin}
                                      checked={
                                        !this.state.disableAtMentionReporter
                                      }
                                      onChange={(checked) =>
                                        this.threadSyncConfigs(
                                          'disableAtMentionReporter',
                                          checked
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            )} */}
                          </Card>
                        </Col>

                        {channel_type === 'support' && (
                          <Col span={this.col_span} id='csat_feedback'>
                            <Card
                              title='CSAT Feedback'
                              key='3'
                              extra={
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <Switch
                                    disabled={
                                      this.state.currentChannelConfigs
                                        ? !isChannelAdmin
                                        : false
                                    } // If currentChannelConfig is not present, no need to disable.
                                    checked={!this.state.disable_CSAT_feedback}
                                    onChange={this.on_CSAT_switch_change}
                                    loading={this.state.loading}
                                  />
                                </div>
                              }
                            >
                              <Paragraph type='secondary'>
                                Send the requestor a message asking for feedback
                                when their {type_of_task} is closed.
                              </Paragraph>
                            </Card>
                          </Col>
                        )}

                        {(!currentChannelConfigs ||
                          isChannelAdmin ||
                          isWorkspaceAdimin) && (
                          <Col span={this.col_span} id='channel_admins'>
                            <ChannelAdmins
                              currentChannelConfigs={
                                this.state.currentChannelConfigs
                              }
                              channel={this.props.channel}
                              isWorkspaceAdimin={isWorkspaceAdimin}
                              isChannelAdmin={isChannelAdmin}
                              userChannels={this.props.userChannels}
                              isGridSharedChannel={
                                this.state.isGridSharedChannel
                              }
                            />
                          </Col>
                        )}

                        <Modal
                          visible={this.state.setFieldValueModal}
                          onCancel={this.toggleSetFieldValueCancel}
                          onOk={this.toggleSetFieldValueOk}
                        >
                          {this.setFieldValueBody()}
                        </Modal>
                        <Col span={this.col_span} id='delete_config'>
                          <Card title='Delete Channel Configuration'>
                            <Text type='secondary'>
                              Delete all configurations in this channel. This
                              change is irreversible.
                            </Text>
                            <br />
                            <br />
                            <Button
                              // type='primary'
                              danger
                              // style={{ marginLeft: "auto", paddingRight: "8px", marginTop: "10px", marginRight: "7px" }}
                              onClick={() =>
                                this.deleteConfiguration(channel_data)
                              }
                            >
                              Delete Channel Configuration
                            </Button>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div>
                      <JiraChannelPreferences
                        // skillView={this.props.skillView}
                        // skill={this.props.assistant_skills}
                        {...this.props}
                        workspace_id={this.props.match.params.wId}
                      />
                    </div>
                  )}
                </Row>
              </Content>
            </Col>
            <Col span={4}>
              <Anchor
                getContainer={() =>
                  document.getElementById('anchor-scroll-content')
                }
                style={{ marginRight: '16px' }}
              >
                <Link
                  href='#creation_behaviour'
                  className={this.anchor_classname}
                  title={
                    channel_type === 'support'
                      ? 'Request creation settings'
                      : 'Issue creation settings'
                  }
                />
                {channel_type === 'support' && (
                  <Link
                    href='#off-hour-settings'
                    className={this.anchor_classname}
                    title='Off hours settings'
                  />
                )}
                {isEmojiMarkersEnabled && (
                  <Link
                    href='#emojiMarkers'
                    className={this.anchor_classname}
                    title='Emoji Markers'
                  />
                )}
                {channel_type === 'agent' && (
                  <Link
                    href='#internal-comments'
                    className={this.anchor_classname}
                    title='Internal comment by default'
                  />
                )}
                {(channel_type === 'project' || channel_type === 'agent') && (
                  <Link
                    href='#notifications'
                    className={this.anchor_classname}
                    title='Notification Subscriptions'
                  />
                )}
                {(channel_type === 'project' || channel_type === 'agent') && (
                  <Link
                    href='#issue_card'
                    className={this.anchor_classname}
                    title='Issue card customization'
                  />
                )}
                <Link
                  href='#unfurl'
                  className={this.anchor_classname}
                  title={
                    channel_type === 'support'
                      ? 'Request Preview (Unfurl)'
                      : 'Issue Preview (Unfurl)'
                  }
                />
                <Link
                  href='#threadsync'
                  className={this.anchor_classname}
                  title='Jira to Slack thread sync condition'
                />
                {channel_type === 'support' && (
                  <Link
                    href='#csat_feedback'
                    className={this.anchor_classname}
                    title='CSAT Feedback'
                  />
                )}
                <Link
                  href='#channel_admins'
                  className={this.anchor_classname}
                  title='Restrict Channel configuration'
                />
                <Link
                  href='#delete_config'
                  className={this.anchor_classname}
                  title='Delete Channel Configuration'
                />
              </Anchor>
            </Col>
          </Row>
        )}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    projects: state.skills.projects,
    issues: state.skills.issues,
    channelDefault: state.skills.channelDefault,
    // assistant_skills: state.skills,
    cardTemplates: state.cards.templateCards,
    commonChanneldata: state.skills.commonChanneldata,
    user_now: state.common_reducer.user,

    channels: state.skills.channels,
    isWorkspaceAdimin: state.common_reducer.isAdmin,
    global_row_gutter: state.common_reducer.global_row_gutter,
    skills: state.skills.skills,
    team: state.skills.team,
    statuses: state.skills.statuses,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    updateCommonChannelDataApi,
    setDefaultChannel,
    getDefaultChannel,
    getIssues,
    getProject,
    getAssisantSkills,
    getJiraBoards,
    deleteDefaultChannel,
    deleteChannelConfigurations,
    getServiceDeskProject,
    channelAdminConfig,
    updateChannelCommonData,
    searchJiraProjects,
    creatorAsAssignee,
    dropDownSearchJiraProjects,
    getConfluenceChannelConfig,
    addConfluenceChannelConfig,
    updateCommonChannelData,
    getJiraProjectStatues,
  })(JiraChannelPreference)
);
